/**
 * @module app.bdc.list.orderCtrl
 *
 */
define(['angular', 'moment'], function (angular, moment) {

        function OrderCtrl(
            $rootScope,
            $location,
            $log,
            orderFormService,
            orderService,
            $scope,
            pricesService,
            clientService,
            Notification,
            reportRoutingService,
            $uibModal,
            marketService,
            tillPackService,
            boulangerieService,
            multiStoresService,
            userService,
            goodwillGesturesService,
            commissionService,
            ladditionService,
            tpeService,
            offerService,
            contractTypeService,
            orderTypeService,
            promotionService,
            unitBonusService,
            walletService
        ) {
            var self = {};

            self.discountAllowed = goodwillGesturesService.ALLOWED_DISCOUNT_RATE;

            /* =========================================================================================== */
            /*                                         INIT                                                */
            /* =========================================================================================== */
            self.orderForm = $rootScope.orderForm;

            if (!self.orderForm) {
                return $scope.goTo('/bdc/list');
            }

            self.goToList = function goToList() {
                return $scope.goTo('/bdc/list');
            };

            self.order = $rootScope.order;

            // We filter all options and cashDrawers prices according to the validityDate of the offer
            self.orderForm.options.forEach(function (option) {
                option.prices = orderService.filterOptionPrices(option, self.order);
            });

            self.orderForm.cashDrawers.forEach(function (drawer) {
                drawer.prices = orderService.filterOptionPrices(drawer, self.order);
            });

            self.orderForm.tillPrices.forEach(till =>{
                till.prices = orderService.filterTillPrices(till, self.order);
            });

            // Init the offer
            if (typeof self.order.offer === 'undefined') {
                self.order.offer = self.orderForm.offers[0];
            }

            // Init Package
            if (typeof self.order.package === 'undefined') {
                self.order.package = {};
            }

            self.contractTypes = $rootScope.orderForm.contractTypes;

            // Init the services
            goodwillGesturesService.setOrderForm(self.orderForm);

            self.orderService = orderService; // Full options and tills attributes init made here (_initOrderTillsAndOptionsPrices)
            self.reportRouting = reportRoutingService;
            self.marketService = marketService;
            self.boulangerieService = boulangerieService;
            self.commissionService = commissionService;
            self.goodwillGesturesService = goodwillGesturesService;
            self.tpeService = tpeService;
            self.offerService = offerService;
            self.orderTypeService = orderTypeService;
            self.promotionService = promotionService;

            // Init the prices
            pricesService.setOrderForm(self.orderForm);
            pricesService.setOrder(self.order);
            unitBonusService.setOrder(self.order);
            self.order.unitBonus.total = unitBonusService.calculTotal();

            self.isSaved = true;

            self.isSalesAdminLite = userService.isSalesAdminLite($rootScope.user) || $rootScope.user.uid === 'bsamain203';
            self.order.isMaintenanceAllowed = false;
            self.order.isTpeAllowed = false;

            self.getOptionFromCode = function getOptionFromCode(code) {
                for (var i = self.orderForm.options.length - 1; i >= 0; i--) {
                    if (
                        self.orderForm.options[i].code === code &&
                        self.orderForm.options[i].orderType.code === self.order.orderType.code
                    ) {
                        return self.orderForm.options[i];
                    }
                }
                return null;
            };

            let optionSoftScanUpProduit = self.getOptionFromCode('SOFT-SCANUP-PRODUIT');
            let optionSoftScanupEncaissement = self.getOptionFromCode('SOFT-SCANUP-ENCAISSEMENT');
            let optionSoftScanUpTabac = self.getOptionFromCode('SOFT-SCANUP-TABAC');
            let optionSoftScanUpPresse = self.getOptionFromCode('SOFT-SCANUP-PRESSE');
            let optionSoftScanupTabacPresse = self.getOptionFromCode('SOFT-SCANUP-TABACPRESSE');
            let optionSoftScanupPaiement = self.getOptionFromCode('SOFT-SCANUP-PAIEMENT');
            let optionSecondPointWifi = self.getOptionFromCode('SECOND-POINT-WIFI');
            let optionPistolGrip = self.getOptionFromCode('PISTOL-GRIP');
            self.nbScanup = 0;

            self.optionBBooster = self.getOptionFromCode('B-BOOSTER');
            self.isOptionBBooster = self.order.options.filter(option => option.code === 'B-BOOSTER').length > 0;

            const prestationInstall = self.getOptionFromCode('INSTALLATION-SITE');
            const prestationInstallStandard = self.getOptionFromCode('INSTALLATION-SITE-STANDARD');
            const prestationInstallExceptionnel = self.getOptionFromCode('INSTALLATION-SITE-HNO');
            const prestationInstallPeripherique = self.getOptionFromCode('INSTALLATION-SITE-PERIPHERIQUE');
            const restaurationEssentiel = self.getOptionFromCode('RESTAURATION-ESSENTIEL');
            const restaurationPremium = self.getOptionFromCode('RESTAURATION-PREMIUM');
            const restaurationUltimate = self.getOptionFromCode('RESTAURATION-ULTIMATE');
            if (prestationInstall || prestationInstallStandard || prestationInstallExceptionnel || prestationInstallPeripherique || restaurationEssentiel || restaurationPremium || restaurationUltimate) {
                self.order.options.map(opt => {
                    if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(opt.code)) {
                        opt.selected = true;
                    }
                    if (self.order.orderType.code !== 'NAP' && self.order.orderType.code !== 'FLORAJET' && (opt.code === restaurationEssentiel.code
                        || opt.code === restaurationPremium.code
                        || opt.code === restaurationUltimate.code)){
                        opt.selected = true;
                    }
                });
            }

            self.dateBridageRemise = '2022-01-07';
            self.dateBridageRemise2 = '2022-09-12';
            self.dateBridageRemise3 = '2026-04-13';

            self.isBEverConnected = function () {
                if(self.order.orderType.code === 'NAP')
                    return false;
                let gestion = [];
                let options = _getOptions();
                options
                    .filter(function (opt) {
                        return !opt.isDeleted;
                    })
                    .forEach(function (opt) {
                        if (opt.optionType.code === 'GESTION' && opt.orderType.code === self.order.orderType.code
                            && (opt.code.indexOf('BEVERCONNECTED') !== -1) && opt.isAvailable)
                            gestion.push(opt);
                    });
                return gestion.length > 0;
            };

            /**
             * Is a TRAD order ?
             * @return {Boolean}
             */
            self.isTRAD = function isTRAD() {
                return self.order.orderType.code === 'TRAD';
            };

            /**
             * Is a FLORAJET order ?
             * @return {Boolean}
             */
            self.isFLORAJET = function isFLORAJET() {
                return self.order.orderType.code === 'FLORAJET';
            };

            /**
             * Is a NAP order ?
             * @return {Boolean}
             */
            self.isNAP = function isNAP() {
                return self.order.orderType.code === 'NAP';
            };

            /**
             * Check the offer of the order (webTill or materialTill)
             * @param val
             * @returns {boolean}
             */
            self.isOffer = function isOffer(val) {
                return self.order.offer.code === val;
            };

            self.isCateringSupport = function (code) {
                return ['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(code) !== -1;
            }





            /* =========================================================================================== */
            /*                                     B CONNECTED                                             */
            /* =========================================================================================== */
            const B_CONNECTED_CODES = {
                PAW: 'PAW',
                FULLEVER: 'FULLEVER',
                PAWEVER: 'PAWEVER'
            };

            const B_CONNECTED_LABELS = {
                PDV_NON_EQUIPE_LIGHT: 'PDV non équipé de B Connected ou équipé d\'un pack B Connected Light',
                PDV_EQUIPE_FULL: 'PDV équipé d\'un pack B Connected Full',
                PDV_NON_EQUIPE_OU_V1: 'PDV non équipé d\'un routeur B Connected ou PDV équipé d\'un routeur B Connected v1',
                PDV_EQUIPE_V1: 'PDV équipé d\'un routeur B Connected v1',
                PDV_EQUIPE_V2: 'PDV équipé d\'un routeur B Connected v2'
            };

            const B_CONNECTED_DESCRIPTIONS = {
                SANS_BMOOV: 'sans BMOOV ni scan\'up',
                AVEC_BMOOV: 'avec BMOOV ou scan\'up',
                EMPTY: ''
            };

            function bConnectedOptions() {
                return [
                    {
                        label: B_CONNECTED_LABELS.PDV_NON_EQUIPE_LIGHT,
                        description: B_CONNECTED_DESCRIPTIONS.SANS_BMOOV,
                        code: B_CONNECTED_CODES.PAW,
                        selected: self.order.bConnected === B_CONNECTED_CODES.PAW
                    },
                    {
                        label: B_CONNECTED_LABELS.PDV_EQUIPE_FULL,
                        description: B_CONNECTED_DESCRIPTIONS.AVEC_BMOOV,
                        code: null,
                        selected: self.order.bConnected === null
                    }
                ];
            }

            function bEverConnectedOptions() {
                return [
                    {
                        label: B_CONNECTED_LABELS.PDV_NON_EQUIPE_OU_V1,
                        description: B_CONNECTED_DESCRIPTIONS.EMPTY,
                        code: B_CONNECTED_CODES.FULLEVER,
                        selected: self.order.bConnected === B_CONNECTED_CODES.FULLEVER
                    },
                    /*{
                        label: B_CONNECTED_LABELS.PDV_EQUIPE_V1,
                        description: B_CONNECTED_DESCRIPTIONS.EMPTY,
                        code: B_CONNECTED_CODES.FULLEVER,
                        selected: self.order.bConnected === B_CONNECTED_CODES.FULLEVER
                    },*/
                    {
                        label: B_CONNECTED_LABELS.PDV_EQUIPE_V2,
                        description: B_CONNECTED_DESCRIPTIONS.EMPTY,
                        code: B_CONNECTED_CODES.PAWEVER,
                        selected: self.order.bConnected === B_CONNECTED_CODES.PAWEVER
                    }
                ];
            }

            self.optionsBConnected = self.isBEverConnected
                ? bEverConnectedOptions()
                : bConnectedOptions();


            self.changeOptionBConnected = function (option) {
                self.optionsBConnected.map(opt => opt.selected = opt.code === option.code);
                // console.log((!self.hasBmoovPack() || !self.hasBmoovPlusPack() || self.nbScanup === 0))
                // if (self.isExtensionScenario() && (!self.hasBmoovPack() || !self.hasBmoovPlusPack() || self.nbScanup === 0)) {
                //     self.order.bConnected = null;
                // } else {
                self.order.bConnected = option.code;
                // }

                let installOption;
                self.order.options.map(opt => {
                    if (['INSTALLATION-SITE','INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(opt.code)) {
                        installOption = opt;
                    }
                });
                // if (self.isDeviceScenario()) {
                //     if (option.code === 'PAW' || option.code === 'PAWEVER') {
                //         _addPrestationInstallOption(installOption);
                //     } else {
                //         _unselectedOption(installOption);
                //     }
                //     _updatePrices();
                // }
            };

            self.bConnectedIsAvailable = function () {
                // if (self.order.orderType.code === 'NAP')
                //     return true;
                let option = [];
                let options = _getOptions();
                options
                    .filter(function (opt) {
                        return !opt.isDeleted;
                    })
                    .forEach(function (opt) {
                        if (opt.optionType.code === 'GESTION' && opt.orderType.code === self.order.orderType.code
                            && (opt.code.indexOf('BCONNECTED') !== -1 || opt.code.indexOf('BEVERCONNECTED') !== -1) && opt.isAvailable) {
                            option.push(opt);
                            }

                    });
                return option.length > 0;
            };

            self.prestationIsAvailable = function () {
                // if (self.order.orderType.code === 'NAP')
                //     return false;
                let options = _getOptions();
                let opts = options
                    .filter(function (opt) {
                        return !opt.isDeleted;
                    })
                    .reduce((curr, option) => {
                        if (option.optionType.code === 'PRESTATION' && option.orderType.code === self.order.orderType.code && option.isAvailable) {
                            curr.push(options)
                        }
                        return curr;
                    }, []);
                return opts.length > 0;
            };

            /* =========================================================================================== */
            /*                                       CONTRACT                                              */
            /* =========================================================================================== */
            self.isContractDefined = self.order.contract.scenarioType.id !== null;

            /**
             * Is the CONQUETE scenario selected ?
             * @return {Boolean}
             */
            self.isConqueteScenario = function () {
                return self.order.contract.scenarioType.code === 'CONQUETE';
            };

            /**
             * Is the RENOUVELLEMENT scenario selected ?
             * @return {Boolean}
             */
            self.isRenouvellementScenario = function () {
                return self.order.contract.scenarioType.code === 'RENOUVELLEMENT';
            };

            /**
             * Is the RENOUVELLEMENT scenario selected ?
             * @return {Boolean}
             */
            self.isExtensionScenario = function () {
                return self.order.contract.scenarioType.code === 'EXTENSION';
            };

            /**
             * Is the device scenario selected ?
             * @return {Boolean}
             */
            self.isDeviceScenario = function isDeviceScenario() {
                return self.order.contract.scenarioType.code === 'PERIPHERIQUE';
            };

            self.setDeloitte = function setDeloitte(val) {
                self.order.isDeloitte = val;
                self.isSaved = false;
            };

            /**
             * Function called on discount input change
             * @param  {Object} option
             */
            self.updateDiscount = function (option) {
                if (option.discount > 0) {
                    // Update goodwillgestures boolean variables
                    if (option.optionType.code === 'SAV' || option.optionType.code === 'MAINTENANCE') {
                        self.isMDS = true;
                    }
                    if (option.optionType.code === 'TPE') {
                        self.isTPE = true;
                    }
                }

                if (option.discount === undefined) {
                    option.discount = self.getMaxDiscountAllowed(option);
                }

                self.isGoodwillGestures = _getIsGG();
                $rootScope.orderDiscounts = orderService.updateDiscountValues(self.order.options);
                _updatePrices();
            };

            /* =========================================================================================== */
            /*                                        MULTISTORES                                          */
            /* =========================================================================================== */

            self.applyCustomRate = function applyCustomRate() {
                _updatePrices();
            };

            self.updateStoresGroup = function updateStoresGroup(order) {
                multiStoresService
                    .updateStoresGroup(order.id, order.storesGroup)
                    .then(function (res) {
                        Notification.success('Informations enregistrées');
                    })
                    .catch(function (err) {
                        $log.error(err);
                        Notification.error('Une erreur est survenue: ' + err.data);
                    });
            };

            self.updateTotal = function updateTotal() {
                self.order.prices.total.rental = pricesService.updateTotal().rental;
                self.order.prices.total.purchase = pricesService.updateTotal().purchase;
            };

            self.hasStoresGroupRights = self.isSalesAdminLite;

            /* =========================================================================================== */
            /*                                        TILLS                                                */
            /* =========================================================================================== */
            self.hasOnlyMaintenancePackage = function (){
                return tillPackService.hasOnlyMaintenancePackage(self.order.tills)
            };

            self.isTills = self.isContractDefined && self.order.tills.length;
            self.limitTills = _updateTillsLimit();
            var _nbTillsById = {};
            var _tills = _getTills();
            self.addedTills = [];
            self.nbTills = 0;
            var _tillToRemove = null;
            self.nbTillsOrderModel = orderService.getNbTillsByTillType(self.order.tills);

            /**
             * Get the limit of tills that an user can add
             * @return {number}
             */
            self.getLimitTillsToAdd = function getLimitTillsToAdd() {
                return self.limitTills - self.nbTills;
            };

            /**
             * Generate the list of tills
             * @return {Array}
             */
            function _getTills() {
                var res = [];
                for (var i = 0; i < self.orderForm.tills.length; i++) {
                    if (self.orderForm.tills[i].orderType.code === self.order.orderType.code) {
                        _nbTillsById[self.orderForm.tills[i].id] = {nbTills: 0};
                        self.orderForm.tills[i].extendedLabel =
                            self.orderForm.tills[i].tillType.label + ': ' + self.orderForm.tills[i].label;
                        _filterAvailableItems(self.orderForm.tills[i], 'tills');
                        res.push(self.orderForm.tills[i]);
                    }
                }
                return res;
            }

            /**
             * Update the mds limit
             */
            function _updateMDSLimit() {
                var nbMDSRDS = self.getLimitMDSRDS();
                if (self.order.goodwillGestures.mds.nbMDSRDS > nbMDSRDS) {
                    self.order.goodwillGestures.mds.nbMDSRDS = nbMDSRDS;
                    self.order.goodwillGestures.mds.nbMDSDRV = 0;
                    self.modalGGMDSRDS = nbMDSRDS;
                }
            }

            /**
             * Add a till to the order model
             */
            function _addTills() {
                var ids = Object.keys(_nbTillsById);
                var till, tillToAdd;
                for (var i = ids.length - 1; i >= 0; i--) {
                    if (_nbTillsById[ids[i]].nbTills > 0 && _nbTillsById[ids[i]].nbTills <= self.getLimitTillsToAdd()) {
                        self.nbTills += _nbTillsById[ids[i]].nbTills;

                        // search if the till has been already added in the order model
                        for (var j = 0; j < self.order.tills.length; j++) {
                            till = null;
                            if (self.order.tills[j].id === parseInt(ids[i])) {
                                till = self.order.tills[j];
                                break;
                            }
                        }

                        if (!till) {
                            for (j = 0; j < self.orderForm.tills.length; j++) {
                                if (self.orderForm.tills[j].id === parseInt(ids[i])) {
                                    tillToAdd = self.orderForm.tills[j];
                                    break;
                                }
                            }

                            tillToAdd.nbTills = _nbTillsById[ids[i]].nbTills;
                            self.order.tills.push(tillToAdd);
                            _selectDefaultOptions(tillToAdd);
                        } else {
                            till.nbTills += _nbTillsById[ids[i]].nbTills;
                        }


                        for (var j = 0; j < _nbTillsById[ids[i]].nbTills; j++) {
                            for (var k = 0; k < _tills.length; k++) {
                                if (_tills[k].id === parseInt(ids[i])) {
                                    self.addedTills.push(_tills[k]);
                                }
                            }
                        }
                    }
                    _nbTillsById[ids[i]].nbTills = 0;
                }
                self.isTills = self.order.tills.length;

                _updateAvailableOptions();
                _updateAvailableTills();
                _updateAvailablePromotions()
                _updateMDSLimit();
                if (self.isWelcomeBonus === true) {
                    self.updateWelcomeBonus();
                }
                _updatePrices();

                self.setDeloitte(self.isDeloitteAvailable());
            }

            /* Tills limits and restrictions*/
            function _checkTillsLimit() {
                let tillPack = orderService.areTillsMixed(self.order.tills);
                let message = '';
                if (offerService.isOlderOffer(self.order) === true) {
                    if (tillPack.isMixed && self.nbTills > 0) {
                        message = 'Vous ne pouvez pas faire de pack de caisse mixte.';
                        Notification.error(message);
                        return true;
                    }
                }
                if (self.nbTills >= self.limitTills) {
                    let limitExplanation = self.order.contract.scenarioType.code === 'EXTENSION' ? ' en Extension.' : '.';
                    message = 'Nombre de caisses limité à ' + self.limitTills + limitExplanation;
                    Notification.warning(message);
                    return true;
                }
                return false;
            }



            /* TillPack functions */

            self.isBtouchPlusPack = function () {
                return tillPackService.isBtouchPlusPack(self.order.tills);
            };

            self.isBtouchPack = function () {
                return tillPackService.isBtouchPack(self.order.tills);
            };

            self.hasBtouchPlusPack = function () {
                return tillPackService.hasBtouchPlusPack(self.order.tills);
            };

            self.hasBtouchPack = function () {
                return tillPackService.hasBtouchPack(self.order.tills);
            };

            self.hasBtouchRefurbishedPack = function () {
                return tillPackService.hasBtouchRefurbishedPack(self.order.tills);
            }

            self.hasBmoovPack = function () {
                return tillPackService.hasBmoovPack(self.order.tills);
            };

            self.hasBmoovPlusPack = function () {
                return tillPackService.hasBmoovPlusPack(self.order.tills);
            };

            self.hasBsmartPack = function () {
                return tillPackService.hasBsmartPack(self.order.tills);
            };

            self.hasBswiftPack = function () {
                return tillPackService.hasBswiftPack(self.order.tills);
            };

            self.hasBgreenPack = function () {
                return tillPackService.hasBgreenPack(self.order.tills);
            };

            self.hasBwidePack = function () {
                return tillPackService.hasBwidePack(self.order.tills);
            };

            self.hasBCompactPack = () => {
                return tillPackService.hasBCompactPack(self.order.tills);
            };

            self.canEnableBTPromotion = function() {
                let promotionsValues = pricesService.calculatePotentialPromotionsAmount();
                const promoBTLimitPrice = {
                    1: {
                        LOC36: 103,
                        LOC48: 79,
                        LOC60: 66,
                        ACHAT: 3388
                    },
                    2: {
                        LOC36: 176,
                        LOC48: 135,
                        LOC60: 113,
                        ACHAT: 5760
                    },
                    3: {
                        LOC36: 248,
                        LOC48: 190,
                        LOC60: 159,
                        ACHAT: 8132
                    },
                    4: {
                        LOC36: 309,
                        LOC48: 237,
                        LOC60: 198,
                        ACHAT: 10164
                    },
                    5: {
                        LOC36: 361,
                        LOC48: 277,
                        LOC60: 231,
                        ACHAT: 11858
                    },
                    6: {
                        LOC36: 402,
                        LOC48: 309,
                        LOC60: 258,
                        ACHAT: 13214
                    },
                };
                if(self.nbTills) {
                    if (self.order.promotions.find(promotion => promotion.code === 'B_TOUCH')) {
                        return (Math.ceil(self.order.prices.leaserSubtotal) >= promoBTLimitPrice[self.nbTills][self.order.contract.contractType.code]);
                    }
                    else {
                        return (Math.ceil(self.order.prices.leaserSubtotal - promotionsValues['B_TOUCH']) >= promoBTLimitPrice[self.nbTills][self.order.contract.contractType.code]);
                    }
                }
                return false;

            }

            function _updateTillsLimit() {
                return self.order.contract.scenarioType.code === 'EXTENSION' ? 1 : 6;
            }

            /**
             * Select the till to remove
             * @param  {int} id
             */
            self.prepareRemoveTill = function prepareRemoveTill(id) {
                _tillToRemove = id;
                _openModalDelete();
            };

            /**
             * Remove the till to delete from the model and add it to the list
             */
            function _removeTill() {
                if (!_tillToRemove) {
                    return;
                }
                let tillPackRemovedCode = null;
                let lastElementOfThisTillPackHasBeenRemoved = false;

                // Delete from the model
                for (var i = 0; i < self.order.tills.length; i++) {
                    if (self.order.tills[i].id === _tillToRemove) {
                        for (var k = 0; k < self.addedTills.length; k++) {
                            if (self.order.tills[i].id === self.addedTills[k].id) {
                                self.addedTills.splice(k, 1);
                                break;
                            }
                        }
                        if (self.order.tills[i].tillType.code) {
                            tillPackRemovedCode = self.order.tills[i].tillType.code;
                        }

                        if (self.order.tills[i].nbTills > 1) {
                            self.order.tills[i].nbTills--;
                        } else {
                            self.order.tills.splice(i, 1);
                            self.isTills = self.order.tills.length;
                            lastElementOfThisTillPackHasBeenRemoved = true;
                        }
                        self.nbTills--;

                        break;
                    }
                }
                _tillToRemove = null;

                if (tillPackRemovedCode) {
                    _resetAssociatedCashDrawers(tillPackRemovedCode);
                    _resetAssociatedOptions(tillPackRemovedCode);
                    // Cas spécifique pour NAP - Les accessoires caisses ne sont visibles que si une caisse B Moov est sélectionnée
                    // if (self.order.orderType.code === 'NAP' && tillPackRemovedCode === 'BM' && !self.hasBmoovPack()) {
                    //     _resetTillAccessories();
                    // }
                    if (lastElementOfThisTillPackHasBeenRemoved) {
                        _resetAssociatedPromotion(tillPackRemovedCode);
                        _resetCashinServices(tillPackRemovedCode);
                        _resetServicesFestival(tillPackRemovedCode);
                    }
                }

                _updateAvailableOptions();
                _updateAvailableTills();
                _updateMDSLimit();
                if (self.isWelcomeBonus === true) {
                    self.updateWelcomeBonus();
                }
                _updatePrices();

                self.setDeloitte(self.isDeloitteAvailable());
            }

            /**
             * Initialize tills for an existing order
             */
            function _initTills() {
                if (!self.order.tills.length) {
                    return;
                }

                for (var i = 0; i < self.order.tills.length; i++) {
                    self.nbTills += self.order.tills[i].nbTills;

                    for (var j = 0; j < self.order.tills[i].nbTills; j++) {
                        self.addedTills.push(self.order.tills[i]);
                    }
                }

                _tills = _getTills();
                _updateAvailableOptions();
                _updateAvailableTills();
            }

            _initTills();

            self.exceptionalOffer = self.nbTills < 4 ? pricesService.calculateExceptionalOffer(true) > 0 : false;

            /* =========================================================================================== */
            /*                                    WEB TILLS                                                */
            /* =========================================================================================== */

            var _webTill = _getTills();
            var _webTillToRemove = null;
            self.addedWebTills = [];
            self.isWebTills = self.isContractDefined && self.order.package.length;

            /**
             * Select the webTill to remove
             * @param  {int} id
             */
            self.prepareRemoveWebTillPackage = function prepareRemoveWebTillPackage(id) {
                _webTillToRemove = id;
                _openModalDelete();
            };

            /**
             * Remove the till to delete from the model and add it to the list
             */
            function _removeWebTill() {
                if (!_webTillToRemove) {
                    return;
                } else if ((self.order.package.id = _webTillToRemove)) {
                    self.order.package = {};
                    self.isSelectedFormule = false;
                    var packages = self.orderForm.packages;
                    for (var till in packages) {
                        packages[till].checked = false;
                    }
                    _updatePrices();
                }
            }

            self.isSelectedFormule = _isSelectedFormule();

            function _isSelectedFormule() {
                if (self.order.package.id) {
                    return true;
                }
                return false;
            }

            function _addWebTillPackages() {
                var packages = self.orderForm.packages;
                for (var till in packages) {
                    if (packages[till].checked) {
                        self.order.package = packages[till];
                        self.isSelectedFormule = _isSelectedFormule();
                    }
                }
                _updatePrices();
            }

            /* =========================================================================================== */
            /*                                    TILL OPTIONS                                             */

            /* =========================================================================================== */

            /**
             * Add or Remove an option to the tillPack (boolean type of option)
             * @method selectTillOption
             * @param  {Object}         option
             * @return {Boolean}        true if the option is selected
             */
            function selectTillOption(option) {
                if (option.optionType.code === 'PACK_BOULANGERIE') {
                    _unselectPacksBoulangerie(option);
                    _unselectModulesBoulangerie();
                    if (self.isWelcomeBonus) {
                        self.removeWelcomeBonus(false);
                        Notification.warning('Prime de bienvenue remise à zéro');
                    }
                    self.boulangeriePack = boulangerieService.getPack(self.order);
                    self.boulangerieModulesLimit = boulangerieService.getBoulangerieModulesLimit(option);
                    self.boulangerieModulesBonus = boulangerieService.getBoulangerieModulesBonus(option);
                }
                if (marketService.isBoulangerieMarket(self.order) && boulangerieService.isModuleBoulangerie(option)) {
                    option.selected ? self.boulangerieModulesChecked++ : self.boulangerieModulesChecked--;
                }
                 if (option.code === 'PACK-B-BOOSTER' || option.code === 'B-BOOSTER') {
                     self.updateDiscount(option);
                 }

                if (option.selected) {
                    if (_isOptionMPDV(option)) {
                        // desélectionner les autres options MPDV
                        _unselectModulesMPDV();
                    }

                    if (_isOptionBrasserie(option)) {
                        // desélectionner les autres options Brasserie
                        _unselectModulesBrasserie();
                    }

                    option.nbOptions = 1;
                    _addOption(option);
                } else {
                    option.nbOptions = 0;
                    _removeOption(option);
                    _updatePrices(); // prices need to be updated because removeOption doesn't call it
                }

                if (option.optionType.code === 'LOGICIEL_CAISSE') {
                    setAvailableModuleBrasserie();
                }

                if (option.code === 'LOGICIEL_CAISSE_TABAC' || option.code === 'LOGICIEL_CAISSE_PRESSE') {
                    if(!option.selected && self.order.isQuickInstallOffer && moment(self.order.dateCreated).isBefore('2025-04-22')){
                        self.removeQuickInstallOffer();
                    }
                }

                self.modules = self.order.options.reduce((curr, opt) => {
                    if (opt.code === 'LOGICIEL_CAISSE_TABAC' || opt.code === 'LOGICIEL_CAISSE_PRESSE' || opt.code === 'LOGICIEL_CAISSE_ENCAISSEMENT') {
                        curr.push(opt.code);
                    }
                    return curr;
                }, []);
                let optionsNotVerified = ['LOGICIEL_CAISSE_BOULANGERIE', 'LOGICIEL_CAISSE_FLEURISTE', 'LOGICIEL_CAISSE_LIBRAIRIE', 'PACK-MPDV-PILOTAGE', 'RESTAURATION-SEUL',
                    'RESTAURATION-COUPLE']
                if (self.nbScanup > 0 && self.modules.indexOf(option.code)) {
                    let count = 0;
                    while (count < self.nbScanup) {
                        if (self.modules.indexOf('LOGICIEL_CAISSE_ENCAISSEMENT') !== -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_TABAC') === -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') === -1 && option.optionType.code !== 'GESTION' && option.optionType.code !== 'MAINTENANCE'
                            && optionsNotVerified.indexOf(option.code) === -1) {
                            self.decreaseNumberOption(optionSoftScanUpTabac);
                            self.decreaseNumberOption(optionSoftScanUpPresse);
                            self.decreaseNumberOption(optionSoftScanupTabacPresse);
                            self.increaseNumberOption(optionSoftScanUpProduit);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') !== -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') === -1) {
                            self.decreaseNumberOption(optionSoftScanUpProduit);
                            self.decreaseNumberOption(optionSoftScanUpPresse);
                            self.decreaseNumberOption(optionSoftScanupTabacPresse);
                            self.increaseNumberOption(optionSoftScanUpTabac);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') === -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') !== -1) {
                            self.decreaseNumberOption(optionSoftScanUpTabac);
                            self.decreaseNumberOption(optionSoftScanUpProduit);
                            self.decreaseNumberOption(optionSoftScanupTabacPresse);
                            self.increaseNumberOption(optionSoftScanUpPresse);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') !== -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') !== -1) {
                            self.decreaseNumberOption(optionSoftScanUpPresse);
                            self.decreaseNumberOption(optionSoftScanUpTabac);
                            self.decreaseNumberOption(optionSoftScanUpProduit);
                            self.increaseNumberOption(optionSoftScanupTabacPresse);
                        }
                        count++;
                    }

                }

                if(['INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(option.code)){
                    if(option.code === 'INSTALLATION-SITE-STANDARD') {
                        _removeOption(prestationInstallExceptionnel);
                        _removeOption(prestationInstallPeripherique);
                        _removeOption(prestationInstall)
                    }
                    if(option.code === 'INSTALLATION-SITE-HNO'){
                        _removeOption(prestationInstallStandard);
                        _removeOption(prestationInstallPeripherique);
                        _removeOption(prestationInstall)
                    }
                    if(option.code === 'INSTALLATION-SITE'){
                        _removeOption(prestationInstallStandard);
                        _removeOption(prestationInstallPeripherique);
                        _removeOption(prestationInstallExceptionnel);
                    }
                    if(option.code === 'INSTALLATION-SITE-PERIPHERIQUE'){
                        _removeOption(prestationInstallStandard);
                        _removeOption(prestationInstallExceptionnel);
                        _removeOption(prestationInstall)
                    }
                }

                const gestionEssentielBConnected = self.getOptionFromCode('PACK-GESTION-ESSENTIEL-BCONNECTED');
                const gestionPremiumBConnected = self.getOptionFromCode('PACK-GESTION-PREMIUM-BCONNECTED');
                const gestionEssentielBEverConnected = self.getOptionFromCode('PACK-GESTION-ESSENTIEL-BEVERCONNECTED');
                const gestionPremiumBEverConnected = self.getOptionFromCode('PACK-GESTION-PREMIUM-BEVERCONNECTED');

                if(['PACK-GESTION-ESSENTIEL-BEVERCONNECTED', 'PACK-GESTION-PREMIUM-BEVERCONNECTED', 'PACK-GESTION-ESSENTIEL-BCONNECTED', 'PACK-GESTION-PREMIUM-BCONNECTED'].includes(option.code)){
                    if(option.code === 'PACK-GESTION-ESSENTIEL-BEVERCONNECTED') {
                        _removeOption(gestionPremiumBEverConnected);
                        _removeOption(gestionEssentielBConnected);
                        _removeOption(gestionPremiumBConnected);
                    }
                    if(option.code === 'PACK-GESTION-PREMIUM-BEVERCONNECTED'){
                        _removeOption(gestionEssentielBEverConnected);
                        _removeOption(gestionEssentielBConnected);
                        _removeOption(gestionPremiumBConnected);
                    }
                    if(option.code === 'PACK-GESTION-ESSENTIEL-BCONNECTED'){
                        _removeOption(gestionEssentielBEverConnected);
                        _removeOption(gestionPremiumBEverConnected);
                        _removeOption(gestionPremiumBConnected);
                    }
                    if(option.code === 'PACK-GESTION-PREMIUM-BCONNECTED'){
                        _removeOption(gestionEssentielBEverConnected);
                        _removeOption(gestionEssentielBConnected);
                        _removeOption(gestionPremiumBEverConnected);
                    }
                }



                if (self.isCateringSupport(option.code)){
                    if(option.code === 'RESTAURATION-ESSENTIEL'){
                        _removeOption(restaurationPremium);
                        _removeOption(restaurationUltimate);
                    }
                    if(option.code === 'RESTAURATION-PREMIUM'){
                        _removeOption(restaurationEssentiel);
                        _removeOption(restaurationUltimate);
                    }
                    if(option.code === 'RESTAURATION-ULTIMATE'){
                        _removeOption(restaurationEssentiel);
                        _removeOption(restaurationPremium);
                    }
                    _updatePrices();
                }

                return option.selected;
            }

            self.selectTillOption = selectTillOption;

            function _unselectPacksBoulangerie(pack) {
                self.options
                    .filter(function (option) {
                        return option.optionType.code === 'PACK_BOULANGERIE' && option.id !== pack.id;
                    })
                    .forEach(function (otherPack) {
                        otherPack.selected = false;
                        otherPack.nbOptions = 0;
                        _removeOption(otherPack);
                    });
            }

            function _unselectModulesBoulangerie() {
                self.boulangerieModulesChecked = 0;
                self.order.options
                    .filter(function (option) {
                        return option.optionType.code === 'LOGICIEL_CAISSE';
                    })
                    .forEach(function (module) {
                        module.selected = false;
                        module.nbOptions = 0;
                        _removeOption(module);
                    });
            }

            function _unselectModulesMPDV() {
                self.order.options
                    .filter(function (option) {
                        return _isOptionMPDV(option);
                    })
                    .forEach(function (module) {
                        module.selected = false;
                        module.nbOptions = 0;
                        _removeOption(module);
                    });
            }

            function _unselectModulesBrasserie() {
                self.order.options
                    .filter(function (option) {
                        return _isOptionBrasserie(option);
                    })
                    .forEach(function (module) {
                        module.selected = false;
                        module.nbOptions = 0;
                        _removeOption(module);
                    });
            }

            function _selectBBooster(selected) {
                self.options
                    .filter(function (option) {
                        return option.code === 'B-BOOSTER';
                    })
                    .forEach(function (opt) {
                        opt.selected = selected;
                        opt.nbOptions = selected ? 1 : 0;
                        selected ? _addOption(opt) : _removeOption(opt);
                    });
                if (!selected) {
                    _resetLaunchBBooster();
                    self.isOptionBBooster = false;
                } else {
                    self.isOptionBBooster = true;
                }
            }

            /**
             * Cette fonction est relativement complexe.
             * Elle permet de switcher d'un module Brasserie à une autre
             *
             * Il existe  module brasserie (similaire) mais à des tarifs différents en fonction de si on est en encaissement
             * seul ou si il il a d'autre module présent dans le bon de commande.
             *
             * En fonction des autres module, on "affiche" le bon module et on "masque" l'autre
             * Si le module était selectionné, on le déselectionne pour sélectionner le nouveau
             */
            function setAvailableModuleBrasserie() {
                // Est ce qu'on est en "Encaissement Seul"
                let otherOptions = ['TABAC', 'PRESSE', 'BOULANGERIE'];
                let encaissementOnly = true;
                self.order.options
                    .filter(function (option) {
                        return option.optionType.code === 'LOGICIEL_CAISSE';
                    })
                    .forEach(function (option) {
                        if (otherOptions.includes(option.label)) {
                            encaissementOnly = false;
                            return;
                        }
                    });

                self.orderForm.options.find(function (option) {
                    return (
                        option.optionType.code === 'LOGICIEL_CAISSE' &&
                        /^RESTAURATION/.test(option.label) && option.label !== 'RESTAURATION seul'
                    );
                }).isMandatory = encaissementOnly;

                let optionBrasserie = self.order.options.find(function (option) {
                    return (
                        option.optionType.code === 'LOGICIEL_CAISSE' &&
                        /^RESTAURATION/.test(option.label) && option.label !== 'RESTAURATION seul'
                    );
                });

                if (encaissementOnly && optionBrasserie) {
                    optionBrasserie.selected = false;
                    _removeOption(optionBrasserie);
                    _updatePrices();
                }
            }

            self.moduleDisplay = function (module){
                if(
                    module.optionType.code === 'LOGICIEL_CAISSE' && module.orderType.code === 'TRAD'
                    && ['PACK-MPDV-PRODUIT', 'PACK-MPDV-CLIENT'].indexOf(module.code) > -1 && self.order.marketType.code === 'FLEURISTE'
                ) {
                    return self.isConqueteScenario() && module.isAvailable;
                }
                return module.isAvailable;
            }

            self.isModulesLimitReached = function isModulesLimitReached() {
                return self.boulangerieModulesChecked >= self.boulangerieModulesLimit;
            };

            self.isModulesMaxReached = function isModulesMaxReached() {
                return self.boulangerieModulesChecked >= self.boulangerieModulesLimit + self.boulangerieModulesBonus;
            };

            self.getOfferedModules = function getOfferedModules() {
                return self.isModulesLimitReached() ? self.boulangerieModulesChecked - self.boulangerieModulesLimit : '0';
            };

            self.modulesDisabled = function modulesDisabled(module) {
                return (
                    self.isModifiable(self.order) === false ||
                    (!module.selected && self.isModulesMaxReached() && boulangerieService.isModuleBoulangerie(module))
                );
            };

            /* ===== Promotions ===== */

            self.promotionService.init(self.orderForm, self.order);
            self.promotions = self.promotionService.getPromotions();
            self.hasOnePromotion = self.promotionService.hasOnePromotion(self.order.promotions);

            self.displayPromotionSection = function () {
                if (self.isOffer('webTill')) {
                    return false;
                }
                if (self.order.marketType.code === 'RESTAURATION') {
                    return false;
                }
                return !self.isDeviceScenario() && !self.isNAP();
            };

            self.promotionFilter = function promotionFilter(promotion) {
                return self.promotionService.promotionIsAvailable(promotion, self.isNAP());
            };


            self.disabledPromotionCondition = function disabledPromotionCondition(promotion) {
                let enableBTPromotion = self.canEnableBTPromotion();
                return !promotionService.promotionCanBeActivated(
                    promotion,
                    self.order.tills,
                    self.isCashinServices || self.isServicesFestival,
                    self.isExceptionalOffer,
                    self.order.options,
                    self.order.cashDrawers,
                    enableBTPromotion
                );
            };

            self.onPromotionChange = function onPromotionChange(promotion) {
                if (promotion.selected) {
                    _enablePromotion(promotion);
                } else {
                    _disablePromotion(promotion);
                }
                // self.order.options.map(opt => self.getMaxDiscountAllowed(opt))
                return promotion.selected;
            };

            // Add promotion from the order model
            function _enablePromotion(promotion) {
                self.order.promotions.push(promotion);
                _updatePrices(true);
            }

            // Delete promotion from the order model
            function _disablePromotion(promotion, shouldBreak) {
                shouldBreak = typeof shouldBreak === 'undefined' ? true : shouldBreak;
                for (var i = 0; i < self.order.promotions.length; i++) {
                    if (self.order.promotions[i].id === promotion.id) {
                        self.order.promotions.splice(i, 1);
                        if(shouldBreak)
                            break;
                    }
                }
                promotion.selected = false;
                _updatePrices();
            }

            /**
             * Reset the promotion from the BDC that are associated with the till pack
             * @param {String} tillType
             * @return {Void}
             */
            function _resetAssociatedPromotion(tillType) {
                let PromotionDeleted = false;
                const promotionCodeToDeleted = promotionService.getPromotionCodeFromTillCode(tillType);

                for (var i = self.order.promotions.length - 1; i >= 0; i--) {
                    if (self.order.promotions[i].code.indexOf(promotionCodeToDeleted) !== -1) {
                        _disablePromotion(self.order.promotions[i]);
                        PromotionDeleted = true;
                    }
                }
                if (PromotionDeleted) {
                    let tillPack = self.order.tills.find(till => till.tillType.code === tillType);
                    let label = tillPack ? tillPack.tillType.label : tillType;
                    Notification.warning('La promotion associée au pack caisse ' + label + ' a été supprimée.');
                }
            }

            /* =========================================================================================== */
            /*                                     Cash drawers                                            */
            /* =========================================================================================== */
            self.cashDrawers = [];
            self.nbCashDrawersById = {};
            self.nbCashDrawersByTillType = {};
            var _nbTotalCashDrawers = 0;

            /**
             * Init cash drawers collection
             */
            function _initCashDrawersList() {
                for (var i = 0; i < self.orderForm.cashDrawers.length; i++) {
                    if (self.orderForm.cashDrawers[i].orderType.code === self.order.orderType.code) {
                        self.nbCashDrawersById[self.orderForm.cashDrawers[i].id] = {nbCashDrawers: 0};
                        if (self.orderForm.cashDrawers[i].tillType.code) {
                            self.nbCashDrawersByTillType[self.orderForm.cashDrawers[i].tillType.code] = {
                                nbCashDrawers: 0
                            };
                        } else {
                            self.nbCashDrawersByTillType['default'] = {nbCashDrawers: 0};
                        }
                        _filterAvailableItems(self.orderForm.cashDrawers[i], 'cashDrawers');
                        self.cashDrawers.push(self.orderForm.cashDrawers[i]);
                    }
                }
            }

            /**
             * Update nb cash drawer mpodel in the order model
             * @param  {Object} cashDrawer
             */
            function _updateNbCashDrawer(cashDrawer) {
                var foundIndex = -1;
                for (var i = 0; i < self.order.cashDrawers.length; i++) {
                    if (self.order.cashDrawers[i].id === cashDrawer.id) {
                        foundIndex = i;
                    }
                }
                if (foundIndex > -1) {
                    self.order.cashDrawers[foundIndex].nbCashDrawers = self.nbCashDrawersById[cashDrawer.id].nbCashDrawers;
                    return;
                }

                cashDrawer.nbCashDrawers = self.nbCashDrawersById[cashDrawer.id].nbCashDrawers;
                self.order.cashDrawers.push(cashDrawer);
            }

            /**
             * Remove cash drower from the order mdoel
             * @param  {int} cashDrawerId
             */
            function _removeCashDrawer(cashDrawerId) {
                for (var i = 0; i < self.order.cashDrawers.length; i++) {
                    if (self.order.cashDrawers[i].id === cashDrawerId) {
                        self.order.cashDrawers.splice(i, 1);
                        return;
                    }
                }
                self.isSaved = false;
            }

            /**
             * Increase the number of the cash drawer
             * @param  {Object} cashDrawer
             */
            self.increaseNumberCashDrawer = function increaseNumberCashDrawer(cashDrawer) {
                self.nbCashDrawersById[cashDrawer.id].nbCashDrawers++;
                if (self.nbCashDrawersByTillType[cashDrawer.tillType.code]) {
                    self.nbCashDrawersByTillType[cashDrawer.tillType.code].nbCashDrawers++;
                } else {
                    self.nbCashDrawersByTillType['default'].nbCashDrawers++;
                }
                _nbTotalCashDrawers++;
                _updateNbCashDrawer(cashDrawer);
                _updatePrices();
                self.isSaved = false;
            };

            /**
             * Decrease the number of the cash drawer
             * @param  {Object} cashDrawer
             */
            self.decreaseNumberCashDrawer = function decreaseNumberCashDrawer(cashDrawer) {
                if (self.nbCashDrawersById[cashDrawer.id].nbCashDrawers === 0) {
                    return;
                }

                if (self.nbCashDrawersById[cashDrawer.id].nbCashDrawers === 1) {
                    _removeCashDrawer(cashDrawer.id);
                }

                if (self.nbCashDrawersByTillType[cashDrawer.tillType.code]) {
                    self.nbCashDrawersByTillType[cashDrawer.tillType.code].nbCashDrawers--;
                } else {
                    self.nbCashDrawersByTillType['default'].nbCashDrawers--;
                }
                self.nbCashDrawersById[cashDrawer.id].nbCashDrawers--;
                _nbTotalCashDrawers--;
                cashDrawer.nbCashDrawers = self.nbCashDrawersById[cashDrawer.id].nbCashDrawers;
                if ( !self.order.cashDrawers.find(c => !c.refurbished) && promotionService.hasBTouchPromotion(self.order.promotions)) {
                    let promotion = self.order.promotions.find(p => p.code === 'B_TOUCH');
                    promotion.selected = false;
                    self.onPromotionChange(promotion);
                }
                if(_nbTotalCashDrawers === 0 &&
                    (promotionService.hasBSwiftPromotion(self.order.promotions) || promotionService.hasBCompactPromotion(self.order.promotions))){
                    if(tillPackService.hasTillPack(self.order.tills, 'BSW_PREMIUM')){
                        _resetAssociatedPromotion('BSW_PREMIUM');
                    }else if (tillPackService.hasTillPack(self.order.tills, 'BSW_ESSENTIEL')){
                        _resetAssociatedPromotion('BSW_ESSENTIEL');
                    }else if (tillPackService.hasTillPack(self.order.tills, 'BC_ESSENTIEL')){
                        _resetAssociatedPromotion('BC_ESSENTIEL');
                    }

                }
                _updatePrices();
            };

            /**
             * Init the nb cash drawers by the order model values
             */
            function _initCashDrawersOrderValues() {
                for (var i = 0; i < self.order.cashDrawers.length; i++) {
                    self.nbCashDrawersById[self.order.cashDrawers[i].id].nbCashDrawers =
                        self.order.cashDrawers[i].nbCashDrawers;
                    if (self.order.cashDrawers[i].tillType.code) {
                        self.nbCashDrawersByTillType[self.order.cashDrawers[i].tillType.code].nbCashDrawers +=
                            self.order.cashDrawers[i].nbCashDrawers;
                    } else {
                        self.nbCashDrawersByTillType['default'].nbCashDrawers += self.order.cashDrawers[i].nbCashDrawers;
                    }
                    _nbTotalCashDrawers += self.order.cashDrawers[i].nbCashDrawers;
                }
            }

            /**
             * On vérifie si un tiroir caisse est disponible en reconditionné
             * @returns {boolean}
             */
            self.isRefurbishedCashDrawers = () => {
                let refurbished = self.cashDrawers.reduce((curr, drawer) => {
                    if (drawer.refurbished && drawer.isAvailable)
                        curr.push(drawer);
                    return curr;
                }, []);
                return refurbished.length > 0;
            }

            /**
             * Check condition if a cash drawer can be added or not
             * @param {object} cashDrawer
             * @param {String} associatedTillType
             * @return {Boolean}
             */
            self.addCashDrawerCondition = function addCashDrawerCondition(cashDrawer, associatedTillType) {
                if (self.isNAP()) {
                    if (associatedTillType && self.nbTillsOrderModel[associatedTillType]) {
                        if (
                            self.nbCashDrawersByTillType[associatedTillType].nbCashDrawers >=
                            self.nbTillsOrderModel[associatedTillType]
                        ) {
                            return false;
                        }
                    }
                }

                return true;
            };

            /**
             * Reset the cash drawers from the BDC that are associated with the till pack
             * @param {String} tillType
             * @return {Void}
             */
            function _resetAssociatedCashDrawers(tillType) {
                let CashDrawerDeleted = false;
                for (var i = self.order.cashDrawers.length - 1; i >= 0; i--) {
                    if (self.order.cashDrawers[i].tillType.code === tillType) {
                        for (var j = self.order.cashDrawers[i].nbCashDrawers; j > 0; j--) {
                            self.decreaseNumberCashDrawer(self.order.cashDrawers[i]);
                        }
                        CashDrawerDeleted = true;
                    }
                }
                if (CashDrawerDeleted) {
                    Notification.warning('Les tiroirs caisses associés au pack caisse ' + tillType + ' ont été supprimés.');
                }
            }

            _initCashDrawersList();
            _initCashDrawersOrderValues();

            /* =========================================================================================== */
            /*                                    PRINTERS                                                 */
            /* =========================================================================================== */

            self.nbPrintersByTillType = {};

            /**
             * Delete other printers in the order and in the orderCtrl.options array
             */
            function _deleteExistingPrinters() {
                for (var i = self.order.options.length - 1; i >= 0; i--) {
                    if (self.order.options[i].optionType.code === 'IMPRIMANTE') {
                        self.order.options.splice(i, 1);
                    }
                }
                for (var i = self.options.length - 1; i >= 0; i--) {
                    if (self.options[i].optionType.code === 'IMPRIMANTE') {
                        self.options[i].nbOptions = 0;
                    }
                }
                _resetPrinterList();
            }

            /**
             *
             * Check if a given printer is the personal printer option (no printer to sell) using printer label
             * @param  {Object}  printer
             * @return {Boolean}
             */
            self.isPersonalPrinter = function isPersonalPrinter(printer) {
                return /perso/.test(printer.label);
            };

            /**
             * Check condition if the addPrinter button should be disabled
             * @param  {Object} printer printer object
             * @return {Boolean}
             */
            self.disabledAddPrinterCondition = function disabledAddPrinterCondition(printer) {
                if (self.isNAP()) {
                    let tillType = printer.tillType.code;
                    if (tillType !== null) {
                        if (self.nbTillsOrderModel[tillType]) {
                            if (self.nbPrintersByTillType[tillType].nbPrinters >= self.nbTillsOrderModel[tillType]) {
                                return true;
                            }
                        }
                    }
                    return false;
                } else {
                    var personalCustomerPrinter = self.options.find(function (option) {
                        return (
                            option.optionType.code === 'IMPRIMANTE' &&
                            self.isPersonalPrinter(option) === true &&
                            option.nbOptions > 0
                        );
                    });

                    return personalCustomerPrinter ? true : self.isPersonalPrinter(printer) && printer.nbOptions === 1;
                }
            };

            /**
             * Specific action when a printer is added
             * @param {Object} printer
             * @return {Boolean}
             */
            self.addPrinterAction = function addPrinterAction(printer) {
                if (self.isPersonalPrinter(printer) === true) {
                    _deleteExistingPrinters();
                }

                return true;
            };

            /* =========================================================================================== */
            /*                                       OPTIONS                                               */
            /* =========================================================================================== */
            self.isOptions = self.isContractDefined && self.order.options.length;
            self.order.scanupContractType = {
                id: self.order.contract.contractType.id,
                label: self.order.contract.contractType.label,
                code: self.order.contract.contractType.code
            };
            self.order.flashupContractType = {
                id: self.order.contract.contractType.id,
                label: self.order.contract.contractType.label,
                code: self.order.contract.contractType.code
            };
            self.order.installContractType = {
                id: self.order.contract.contractType.id,
                label: self.order.contract.contractType.label,
                code: self.order.contract.contractType.code
            };
            self.order.cateringSupportContractType = {
                id: self.order.contract.contractType.id,
                label: self.order.contract.contractType.label,
                code: self.order.contract.contractType.code
            };
            self.isTPEDevices = false;
            self.isDefaultTPEDevice = false;
            self.options = _getOptions();

            /**
             * On vérifie si un accessoire caisse est disponible en reconditionné
             * @returns {boolean}
             */
            self.isRefurbishedAccessories = () => {
                let refurbished = self.options.reduce((curr, opt) => {
                    if (opt.refurbished && opt.isAvailable)
                        curr.push(opt);
                    return curr;
                }, []);
                return refurbished.length > 0;
            }

            // Filters
            // Heading filters are used to show current options added in the order

            self.cashdrawerBSFilter = function(option){
              return option.tillType.code === 'BS';
            };

            self.maintenanceSavHeadingFilter = function maintenanceSavHeadingFilter(option) {
                return (
                    option.nbOptions > 0 && (option.optionType.code === 'MAINTENANCE' || option.optionType.code === 'SAV')
                );
            };

            self.maintenanceSavFilter = function maintenanceSavFilter(option) {
                return option.isAvailable && (option.optionType.code === 'MAINTENANCE' || option.optionType.code === 'SAV');
            };

            self.gestionHeadingFilter = function gestionHeadingFilter(option) {
                return option.nbOptions > 0 && option.optionType.code === 'GESTION';
            };

            self.gestionScanupHeadingFilter = function (option) {
                return option.nbOptions > 0 && option.optionType.code === 'GESTION_SCANUP' ||
                    (option.optionType.code === 'GESTION' && option.code === 'RESEAU-BCONNECTED');
            };

            self.gestionFilter = function gestionFilter(option) {
                return option.isAvailable && option.optionType.code === 'GESTION';
            };

            self.gestionScanupFilter = function (option) {
                return option.isAvailable && option.optionType.code === 'GESTION_SCANUP'||
                    (option.optionType.code === 'GESTION' && option.code === 'RESEAU-BCONNECTED');
            };

            self.prestationHeadingFilter = function (option) {
                return (
                    option.nbOptions > 0 && (option.optionType.code === 'PRESTATION')
                );
            };

            self.prestationInstallFilter = function (option) {
                if (!option || !option.optionType || !self.order.contract.scenarioType) {
                    return false;
                }
                const isPrestationType = option.optionType.code === 'PRESTATION';

                if (!option.isAvailable || !isPrestationType) {
                    return false;
                }
            
                const INSTALLATION_PERIPHERIQUE = ['INSTALLATION-SITE', 'INSTALLATION-SITE-PERIPHERIQUE'];
                const INSTALLATION_STANDARD = ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO'];
            
                const isPeripheriqueScenario = self.order.contract.scenarioType.code === 'PERIPHERIQUE';
            
                return isPeripheriqueScenario 
                    ? INSTALLATION_PERIPHERIQUE.includes(option.code)
                    : INSTALLATION_STANDARD.includes(option.code);
            };

            self.prestationCateringSupportFilter = function (option) {
                return option.isAvailable && option.optionType.code === 'PRESTATION'
                    && self.isCateringSupport(option.code);
            };

            self.optionsFilter = function optionsFilter(option) {
                return (
                    option.optionType.code === 'SCANUP' ||
                    option.optionType.code === 'FLASHUP' ||
                    option.optionType.code === 'DEFAUT'
                );
            };

            /**
             * get the correct orderType options from the orderForm and compute according values
             * @return {Array}
             */
            function _getOptions() {
                var res = [];
                var found = false;
                for (var i = 0; i < self.orderForm.options.length; i++) {
                    for (var j = 0; j < self.order.options.length; j++) {
                        if (self.orderForm.options[i].id === self.order.options[j].id) {
                            found = true;
                            break;
                        }
                    }
                    _filterAvailableItems(self.orderForm.options[i], 'options');

                    if (!found) {
                        if (self.orderForm.options[i].orderType.code === self.order.orderType.code) {
                            self.orderForm.options[i].nbOptions = 0;

                            if (self.orderForm.options[i].optionType.code === 'SCANUP') {
                                self.orderForm.options[i].contractType = self.order.scanupContractType;
                            }

                            if (self.orderForm.options[i].optionType.code === 'FLASHUP') {
                                self.orderForm.options[i].contractType = self.order.flashupContractType;
                            }

                            if (self.orderForm.options[i].optionType.code === 'PRESTATION') {
                                if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.orderForm.options[i].code)) {
                                    self.orderForm.options[i].contractType = self.order.installContractType;
                                }
                                if (self.isCateringSupport(self.orderForm.options[i].code)){
                                    self.orderForm.options[i].contractType = self.order.cateringSupportContractType;
                                }
                            }
                            res.push(self.orderForm.options[i]);
                        }
                    } else {
                        res.push(self.orderForm.options[i]);
                    }

                    found = false;
                }
                _updateAvailableOptions();
                return res;
            }

            function _getActiveModuleForDiscount() {
                const mods = self.order.options.filter(opt => opt.code === 'LOGICIEL_CAISSE_TABAC' || opt.code === 'LOGICIEL_CAISSE_PRESSE'
                    || opt.code === 'LOGICIEL_CAISSE_BOULANGERIE' || opt.code === 'RESTAURATION-COUPLE' || opt.code === 'RESTAURATION-SEUL'
                    || opt.code === 'LOGICIEL_CAISSE_LIBRAIRIE' || opt.code === 'LOGICIEL_CAISSE_FLEURISTE');
                return mods.length > 0;
            }

            self.getMaxDiscountAllowed = function (option) {
                let maxDiscountAllowed = 100;
                if (option.optionType.code === 'TPE') {
                    // if(self.isConqueteScenario() || self.isExtensionScenario()) {
                    //   if(option.label === 'TPE V200 Terminal filaire') {
                    //     maxDiscountAllowed = 100;
                    //   }
                    // }

                    // if(self.isRenouvellementScenario()) {
                    //   maxDiscountAllowed = 100;
                    // }

                    if (option.label === 'TPE V240 Terminal Portable Bluetooth') {
                        maxDiscountAllowed = 50;
                    }

                    if (option.label === 'TPE Desk 5000 Terminal filaire') {
                        if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise2)) {
                            if (self.isSalesAdminLite) {
                                maxDiscountAllowed = 100;
                                self.order.isTpeAllowed = true;
                            } else {
                                maxDiscountAllowed = _getActiveModuleForDiscount() && self.order.marketType.code !== 'AUTRE'
                                    ? moment(self.order.dateCreated).isAfter(self.dateBridageRemise3) ? 40 : 50
                                    : 30;
                            }
                        } else if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise)) {
                            maxDiscountAllowed = self.isSalesAdminLite ? 100 : 75;
                        } else {
                            maxDiscountAllowed = 50;
                        }
                    }

                    if (option.label === 'TPE Move 5000 Terminal Portable Bluetooth') {
                        if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise2)) {
                            if (self.isSalesAdminLite) {
                                maxDiscountAllowed = 100;
                                self.order.isTpeAllowed = true;
                            } else {
                                maxDiscountAllowed = _getActiveModuleForDiscount() ? 20 : 15;
                            }
                        } else if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise)) {
                            maxDiscountAllowed = self.isSalesAdminLite ? 100 : 25;
                        } else {
                            maxDiscountAllowed = 0;
                        }
                    }

                    if (option.code === 'TPE_DX_4000'){
                        if (self.isSalesAdminLite) {
                            maxDiscountAllowed = 100;
                            self.order.isTpeAllowed = true;
                        } else {
                            maxDiscountAllowed = _getActiveModuleForDiscount() ? 50 : 30;
                        }
                    }

                    if (['TPE_DX_8000', 'TPE_DX_8000_4G'].includes(option.code) ) {
                        if (self.isSalesAdminLite) {
                            maxDiscountAllowed = 100;
                            self.order.isTpeAllowed = true;
                        } else {
                            maxDiscountAllowed = _getActiveModuleForDiscount() ? 30 : 15;
                        }
                    }


                }

                if (option.optionType.code === 'MAINTENANCE') {
                    if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise2)) {
                        if (self.isExceptionalOffer){
                            maxDiscountAllowed = self.isSalesAdminLite ? 100 : 75;
                            self.order.isMaintenanceAllowed = !!self.isSalesAdminLite;
                        }
                        else if (_getActiveModuleForDiscount() && self.order.marketType.code !== 'AUTRE' && self.order.marketType.code !== 'FLEURISTE') {
                            if (!self.hasBsmartPack() && !self.hasBgreenPack() && !self.hasBwidePack()) {
                                if(((self.order.promotions.length > 0 || self.hasBtouchRefurbishedPack()) || self.hasBswiftPack() || self.hasBtouchPack()
                                    || self.hasBCompactPack()) && !self.isSalesAdminLite){
                                    maxDiscountAllowed = 75;
                                }else {
                                    maxDiscountAllowed = 100;
                                    self.order.isMaintenanceAllowed = true;
                                }

                            }
                        } else {
                            maxDiscountAllowed = self.isSalesAdminLite ? 100 : 50;
                            self.order.isMaintenanceAllowed = !!self.isSalesAdminLite;
                        }
                    } else if (moment(self.order.dateCreated).isAfter(self.dateBridageRemise) &&
                        !self.hasBsmartPack() && !self.hasBgreenPack()&& !self.hasBswiftPack() && !self.hasBwidePack() ) {
                        maxDiscountAllowed = self.isSalesAdminLite ? 100 : 75;
                    }
                }
                return maxDiscountAllowed;
            };

            /**
             * Increase the number of an option
             * @param {Object} option
             * @param {int} max
             */
            self.increaseNumberOption = function increaseNumberOption(option, max) {
                if (option !== null) {
                    if (!_beforeIncreaseNumberOption(option, max)) {
                        return;
                    }

                    if (isNaN(option.nbOptions)) {
                        option.nbOptions = 0;
                    }
                    option.nbOptions++;

                    if (self.nbPrintersByTillType[option.tillType.code]) {
                        self.nbPrintersByTillType[option.tillType.code].nbPrinters++;
                    } else {
                        self.nbPrintersByTillType['default'].nbPrinters++;
                    }

                    _addOption(option);

                    if (option.code === 'SCANUP-EVOLUTION' && orderService.isScanUpProductAllowed(self.order)) {
                        if(option.nbOptions === 1)
                            openAskPistolGripModal();
                        let installOption;
                        for (let i = 0; i < self.order.options.length; i++) {
                            if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                                installOption = self.order.options[i];
                        }
                        if(self.isRenouvellementScenario() && self.hasOnlyMaintenancePackage()) {
                            _addPrestationInstallOption(installOption);
                            // _unselectedOption(installOption)
                        }
                        self.modules = self.order.options.reduce((curr, opt) => {
                            if (opt.code === 'LOGICIEL_CAISSE_ENCAISSEMENT' || opt.code === 'LOGICIEL_CAISSE_TABAC' || opt.code === 'LOGICIEL_CAISSE_PRESSE') {
                                curr.push(opt.code);
                            }
                            return curr;
                        }, []);
                        if ((self.modules.indexOf('LOGICIEL_CAISSE_ENCAISSEMENT') !== -1
                                && self.modules.indexOf('LOGICIEL_CAISSE_TABAC') === -1
                                && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') === -1)
                            || self.isDeviceScenario()) {
                            self.increaseNumberOption(optionSoftScanUpProduit);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') !== -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') === -1) {
                            self.increaseNumberOption(optionSoftScanUpTabac);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') === -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') !== -1) {
                            self.increaseNumberOption(optionSoftScanUpPresse);
                        }

                        if (self.modules.indexOf('LOGICIEL_CAISSE_TABAC') !== -1
                            && self.modules.indexOf('LOGICIEL_CAISSE_PRESSE') !== -1) {
                            self.increaseNumberOption(optionSoftScanupTabacPresse);
                        }
                    }
                    if(option.code === 'SOFT-SCANUP-ENCAISSEMENT')
                        self.order.goodwillGestures.amount.clubBimediaEncaissementMobile = 50;
                }
            };

            /**
             * Decrease the number of an option
             * @param  {object}  option
             */
            self.decreaseNumberOption = function decreaseNumberOption(option) {
                if (option.nbOptions === 0) {
                    return;
                }

                if (option.nbOptions === 1) {
                    _removeOption(option);
                }

                option.nbOptions--;

                if (option.isScanupDevice) {
                    self.nbScanup = option.nbOptions;
                    if(self.nbScanup === -1){
                        let installOption;
                        for (let i = 0; i < self.order.options.length; i++) {
                            if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                                installOption = self.order.options[i];
                        }
                        if(self.isRenouvellementScenario() && self.hasOnlyMaintenancePackage()) {
                            // _addPrestationInstallOption(installOption);
                            _unselectedOption(installOption)
                        }
                        if(self.isFullPremiumOffer){
                            self.removeFullPremiumOffer();
                            Notification.warning("L'offre Pack full premium a été désactivée.");
                        }
                    }
                    if (optionSoftScanupTabacPresse.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSoftScanupTabacPresse);
                    }
                    if (optionSoftScanUpTabac.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSoftScanUpTabac);
                    }
                    if (optionSoftScanUpPresse.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSoftScanUpPresse);
                    }
                    if (optionSoftScanupEncaissement.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSoftScanupEncaissement);
                    }
                    if (optionSoftScanupPaiement && optionSoftScanupPaiement.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSoftScanupPaiement);
                    }
                    if (optionSecondPointWifi.nbOptions > self.nbScanup) {
                        self.decreaseNumberOption(optionSecondPointWifi);
                    }
                }

                if (self.nbPrintersByTillType[option.tillType.code]) {
                    self.nbPrintersByTillType[option.tillType.code].nbPrinters--;
                } else {
                    self.nbPrintersByTillType['default'].nbPrinters--;
                }

                if(option.code === 'SCANNER-GRYPHON' && option.nbOptions === 0 &&
                    (promotionService.hasBSwiftPromotion(self.order.promotions) || promotionService.hasBCompactPromotion(self.order.promotions))){
                    if(tillPackService.hasTillPack(self.order.tills, 'BSW_PREMIUM')){
                        _resetAssociatedPromotion('BSW_PREMIUM');
                    }else if(tillPackService.hasTillPack(self.order.tills, 'BSW_ESSENTIEL')){
                        _resetAssociatedPromotion('BSW_ESSENTIEL');
                    }else if (tillPackService.hasTillPack(self.order.tills, 'BC_ESSENTIEL')){
                        _resetAssociatedPromotion('BC_ESSENTIEL');
                    }
                }

                _updatePrices();

                if (option.code === 'SCANUP-EVOLUTION' && orderService.isScanUpProductAllowed(self.order)) {
                    self.decreaseNumberOption(optionSoftScanUpProduit);
                }

                if (!self.activateLaunchBimediaPayCondition) {
                    self.removeLaunchBimediaPay();
                }

                if(option.code === 'SOFT-SCANUP-ENCAISSEMENT' && option.nbOptions === 0)
                    self.order.goodwillGestures.amount.clubBimediaEncaissementMobile = 0;
            };

            /**
             * Select the scanup contract type
             * @param  {String} contractType
             */
            self.selectScanupContractType = function selectScanupContractType(contractTypeCode) {
                self.order.scanupContractType.code = contractTypeCode;
                var tmp = contractTypeService.getContractTypeByCode(contractTypeCode);
                for (var i = 0; i < self.order.options.length; i++) {
                    if (
                        self.order.options[i].optionType.code === 'SCANUP' &&
                        self.order.options[i].code !== 'SOFT-SCANUP-PAIEMENT'
                    ) {
                        self.order.options[i].contractType.id = tmp.id;
                        self.order.options[i].contractType.code = tmp.code;
                        self.order.options[i].contractType.label = tmp.label;
                    }
                }
                if (self.isLaunchBimediaPay) {
                    self.order.goodwillGestures.amount.launchBimediaPay = pricesService.calculateLaunchBimediaPayTotal(
                        self.order
                    );
                }
                _updatePrices();
            };

            /**
             * Select the Install on site contract type
             * @param  {String} contractTypeCode
             */
            self.selectInstallContractType = function (contractTypeCode) {
                self.order.installContractType.code = contractTypeCode;
                var tmp = contractTypeService.getContractTypeByCode(contractTypeCode);
                for (var i = 0; i < self.order.options.length; i++) {
                    if (
                        self.order.options[i].optionType.code === 'PRESTATION' &&
                        ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code)
                    ) {
                        self.order.options[i].contractType.id = tmp.id;
                        self.order.options[i].contractType.code = tmp.code;
                        self.order.options[i].contractType.label = tmp.label;
                    }
                }

                _updatePrices();
            };

            /**
             * Select the Catering support type
             * @param  {String} contractTypeCode
             */
            self.selectCateringSupportContractType = function (contractTypeCode) {
                self.order.cateringSupportContractType.code = contractTypeCode;
                var tmp = contractTypeService.getContractTypeByCode(contractTypeCode);
                for (var i = 0; i < self.order.options.length; i++) {
                    if (
                        self.order.options[i].optionType.code === 'PRESTATION' &&
                        self.isCateringSupport(self.order.options[i].code)
                    ) {
                        self.order.options[i].contractType.id = tmp.id;
                        self.order.options[i].contractType.code = tmp.code;
                        self.order.options[i].contractType.label = tmp.label;
                    }
                }

                _updatePrices();
            };

            /**
             * Find the correct wifi repeater from orderform and add one in the order
             */
            function addRepeater() {
                var repeater = self.orderForm.options.find(function (option) {
                    return orderService.isMandatoryWifiRepeater(option, self.order.orderType.code);
                });
                if (!repeater) {
                    return;
                }

                self.increaseNumberOption(repeater);
                Notification.info("Point d'accès wifi supplémentaire ajouté (obligatoire avec la Scan'Up)");
            }

            function _beforeIncreaseNumberOption(option, max) {
                if (option && option.isScanupDevice) {
                    self.nbScanup = option.nbOptions + 1;
                }
                if (max && option.nbOptions === max) {
                    return false;
                }

                // Service amount is limited to 1
                if (option.isService && option.nbOptions >= 1) {
                    return false;
                }

                if (orderService.isScanupSoftware(option, self.order.orderType.code)) {
                    if (orderService.getAuthorizedScanupSoftwareIds(self.order).indexOf(option.id) === -1) {
                        Notification.error('Vous devez choisir les mêmes options logicielles que pour la caisse');
                        return false;
                    }

                    // var alreadySelectedScanupSoftwareOption = orderService.getSelectedScanupSoftwareOption(self.order);
                    // console.log(option, alreadySelectedScanupSoftwareOption);
                    // if (alreadySelectedScanupSoftwareOption && option.id !== alreadySelectedScanupSoftwareOption.id) {
                    //     Notification.error('Toutes les options logiciel selectionnées doivent être identiques');
                    //     return false;
                    // }
                }
                if (
                    ['SOFT-SCANUP-PAIEMENT', 'SOFT-SCANUP-TABACPRESSE', 'SOFT-SCANUP-TABAC',
                        'SOFT-SCANUP-PRESSE', 'SOFT-SCANUP-ENCAISSEMENT', 'SOFT-SCANUP-PRODUIT'].indexOf(option.code) !== -1
                    && option.nbOptions >= self.nbScanup
                ) {
                    return false;
                }

                return true;
            }

            /**
             * Est ce que cette option est un Pack MPDV ?
             *
             * @param option
             * @return {boolean}
             * @private
             */
            function _isOptionMPDV(option) {
                return option.optionType.code === 'LOGICIEL_CAISSE' && /^Pack MPDV/.test(option.label);
            }

            /**
             * Est ce que cette option est un module Brasserie ?
             *
             * @param option
             * @return {boolean}
             * @private
             */
            function _isOptionBrasserie(option) {
                return option.optionType.code === 'LOGICIEL_CAISSE' && /^RESTAURATION/.test(option.label);
            }

            /**
             * Add an option to the order model
             */
            function _addOption(option) {
                var foundIndex = -1;
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].id === option.id) {
                        foundIndex = i;
                    }
                }

                if (foundIndex === -1) {
                    option.nbOffered = null;
                    option.isAdditional = false;

                    if (option.optionType.code === 'SCANUP') {
                        if (option.code === 'SOFT-SCANUP-PAIEMENT') {
                            option.contractType = {
                                id: 6,
                                code: 'SANSENG',
                                label: 'Mensuel sans engagement'
                            };
                        } else {
                            option.contractType = self.order.scanupContractType;
                        }
                    } else if (option.optionType.code === 'FLASHUP') {
                        option.contractType = self.order.flashupContractType;
                    } else if (option.code === 'PACK-B-BOOSTER') {
                        option.contractType = {
                            id: 6,
                            code: 'SANSENG',
                            label: 'Mensuel sans engagement'
                        };
                    } else if (option.optionType.code === 'PRESTATION') {
                        if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(option.code)) {
                            option.contractType = self.order.installContractType;
                        }
                        if (self.isCateringSupport(option.code)) {
                            option.contractType = self.order.cateringSupportContractType;
                        }
                    } else {
                        option.contractType = {
                            id: null,
                            code: null,
                            label: null
                        };
                    }

                    if (option.isTPEDevice) {
                        option.nbOffered = 0;
                    }

                    // Boulangerie modules offered
                    if (marketService.isBoulangerieMarket(self.order)) {
                        if (self.boulangerieModulesChecked === self.boulangerieModulesLimit) {
                            boulangerieService.resetOfferedModules(self.order);
                        }

                        if (
                            self.boulangerieModulesChecked > self.boulangerieModulesLimit &&
                            boulangerieService.isModuleBoulangerie(option)
                        ) {
                            option.nbOffered = 1;
                        }
                    }

                    self.order.options.push(option);
                }
                _afterAddOption(option);
            }

            /**
             * Instructions to execute after adding and option to the order
             * @param {Object} option
             */
            function _afterAddOption(option) {
                if (option.optionType.code === 'SCANUP' && option.isScanupDevice && self.order.contract.scenarioType.code !== 'PERIPHERIQUE') {
                    console.log(self.bConnectedIsAvailable());
                    if (self.bConnectedIsAvailable()) {
                        if(self.isBEverConnected())
                            self.order.bConnected = self.order.contract.scenarioType.code !== 'EXTENSION' ? 'FULLEVER' : 'PAWEVER';
                        else
                            self.order.bConnected = self.order.contract.scenarioType.code !== 'EXTENSION' ? 'FULL' : 'PAW';
                    } else {
                        self.order.bConnected = null;
                    }
                }

                self.isOptions = self.order.options.length;
                _isTPEDevices();
                _updatePrices();
            }

            /**
             * Remove the option from the order model
             * @param {Object} option
             */
            function _removeOption(option) {
                // Delete from order model
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].id === option.id) {
                        self.order.options[i].selected = false;
                        self.order.options.splice(i, 1);
                        self.isOptions = self.order.options.length;
                        break;
                    }
                }

                if ( option.code === 'SCANNER-GRYPHON' && promotionService.hasBTouchPromotion(self.order.promotions)) {
                    let promotion = self.order.promotions.find(p => p.code === 'B_TOUCH');
                    promotion.selected = false;
                    self.onPromotionChange(promotion);
                }

                if (marketService.isBoulangerieMarket(self.order)) {
                    if (self.boulangerieModulesChecked === self.boulangerieModulesLimit) {
                        boulangerieService.resetOfferedModules(self.order);
                    }
                }

                if (option.isScanupDevice) {
                    if (self.bConnectedIsAvailable() && !self.hasOnlyMaintenancePackage() ) {
                        if (self.isDeviceScenario()) {
                            self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() ? 'FULL' : 'LIGHT';
                        } else if (self.isExtensionScenario()) {
                            self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() ? self.isBEverConnected() ? 'PAWEVER' : 'PAW' : null;
                        } else {
                            if(self.isBEverConnected()){
                                self.order.bConnected = 'FULLEVER';
                            } else {
                                self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() ? 'FULL' : 'LIGHT';
                            }
                        }
                    } else {
                        self.order.bConnected = null;
                    }

                }

                _isTPEDevices();
                _checkScanupOptions();
                if (!self.activateLaunchBimediaPayCondition()) {
                    _resetLaunchBimediaPay();
                }
                if (!self.activateScanupServicesCondition()) {
                    _resetScanupServices();
                }
            }

            /**
             * Init printers from orderForm metadata
             */
            function _initPrinterList() {
                for (var i = 0; i < self.orderForm.options.length; i++) {
                    if (self.orderForm.options[i].optionType.code === 'IMPRIMANTE') {
                        if (self.orderForm.options[i].tillType.code) {
                            self.nbPrintersByTillType[self.orderForm.options[i].tillType.code] = {nbPrinters: 0};
                        } else {
                            self.nbPrintersByTillType['default'] = {nbPrinters: 0};
                        }
                    }
                }
            }

            /**
             * Reset printers list
             */
            function _resetPrinterList() {
                Object.keys(self.nbPrintersByTillType).forEach(function (tillType) {
                    self.nbPrintersByTillType[tillType] = {nbPrinters: 0};
                });
            }

            /**
             * Initialize options for an existing order
             */
            function _initOptions() {
                if (!self.order.options.length) {
                    return;
                }

                if (marketService.isBoulangerieMarket(self.order)) {
                    self.boulangerieModulesChecked = 0;
                    self.boulangeriePack = boulangerieService.getPack(self.order) || {label: ''};
                    self.boulangerieModulesLimit = 0;
                    self.boulangerieModulesBonus = 0;
                }

                // Used to set the scanupInstallation attribute for the order
                _isCorrectScanupInstallationAmount();

                // Computed options parameters
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].optionType.code === 'SCANUP') {
                        if (self.order.options[i].code !== 'SOFT-SCANUP-PAIEMENT') {
                            self.order.scanupContractType = self.order.options[i].contractType;
                        }
                        if (self.order.options[i].isScanupDevice) {
                            self.nbScanup = self.order.options[i].nbOptions;
                        }
                    }
                    if (self.order.options[i].optionType.code === 'FLASHUP') {
                        self.order.flashupContractType = self.order.options[i].contractType;
                    }
                    if (self.order.options[i].optionType.code === 'PRESTATION') {
                        if(['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code)){
                            self.order.installContractType = self.order.options[i].contractType;
                        }
                        if (self.isCateringSupport(self.order.options[i].code)) {
                            self.order.cateringSupportContractType = self.order.options[i].contractType;
                        }
                    }
                    if (
                        self.order.options[i].optionType.code === 'LOGICIEL_CAISSE' ||
                        self.order.options[i].optionType.code === 'EXTENSION'
                    ) {
                        self.order.options[i].selected = true;
                    }
                    if (
                        self.order.options[i].optionType.code === 'MAINTENANCE' ||
                        self.order.options[i].optionType.code === 'SAV' ||
                        self.order.options[i].optionType.code === 'GESTION' ||
                        self.order.options[i].optionType.code === 'GESTION_SCANUP'
                    ) {
                        self.order.options[i].selected = true;
                    }
                    if (
                        self.order.options[i].code === 'MULTI-DEVICE' ||
                        self.order.options[i].code === 'B-BOOSTER' ||
                        self.order.options[i].code === 'PACK-B-BOOSTER'
                    ) {
                        self.order.options[i].selected = true;
                    }
                    if (marketService.isBoulangerieMarket(self.order)) {
                        if (self.order.options[i].optionType.code === 'PACK_BOULANGERIE') {
                            self.order.options[i].selected = true;
                            self.boulangerieModulesLimit = boulangerieService.getBoulangerieModulesLimit(
                                self.order.options[i]
                            );
                            self.boulangerieModulesBonus = boulangerieService.getBoulangerieModulesBonus(
                                self.order.options[i]
                            );
                        } else if (
                            boulangerieService.isModuleBoulangerie(self.order.options[i]) &&
                            self.order.options[i].selected
                        ) {
                            self.boulangerieModulesChecked++;
                        }
                    }
                    if (self.order.options[i].optionType.code === 'IMPRIMANTE') {
                        if (self.order.options[i].tillType.code) {
                            self.nbPrintersByTillType[self.order.options[i].tillType.code].nbPrinters++;
                        } else {
                            self.nbPrintersByTillType['default'].nbPrinters++;
                        }
                    }
                }
            }

            /**
             * Sets Tpe devices presence in the order by updating self.isTPEDevices and self.isDefaultTPEDevice booleans
             * Then resets TPE and LOGICIEL options if there is no TPE present
             */
            function _isTPEDevices() {
                self.isTPEDevices = false;
                self.isDefaultTPEDevice = false;

                // Update TPE presence boolean and push on into rootScope.order
                for (var i = 0; i < self.order.options.length; i++) {
                    if (
                        self.order.options[i].isTPEDevice &&
                        (self.order.options[i].nbOptions > 0 || self.order.options[i].nbOffered > 0)
                    ) {
                        self.isTPEDevices = true;

                        if (self.order.options[i].isDefault) {
                            self.isDefaultTPEDevice = true;
                        }
                    }
                }

                $rootScope.order.isTPEDevices = self.isTPEDevices;

                // Reset pinpad number and remove it from the order if there is no default TPE
                if (!self.isDefaultTPEDevice) {
                    for (var i = self.order.options.length - 1; i >= 0; i--) {
                        if (self.order.options[i].optionType.code === 'TPE' && _isPinpad(self.order.options[i].label)) {
                            self.order.options[i].nbOptions = 0;
                            self.order.options.splice(i, 1);
                        }
                    }
                }

                // Reset options number and remove thme from the order if there is no TPE
                if (!self.isTPEDevices) {
                    for (var i = self.order.options.length - 1; i >= 0; i--) {
                        if (
                            (self.order.options[i].optionType.code === 'TPE' ||
                                self.order.options[i].optionType.code === 'LOGICIEL') &&
                            tpeService.isOptionIndependant(self.order.options[i]) === false
                        ) {
                            self.order.options[i].nbOptions = 0;
                            self.order.options.splice(i, 1);
                        }
                    }
                }
            }

            function _isPinpad(label) {
                return /Pinpad/.test(label);
            }

            self.isPinpad = _isPinpad;

            /**
             * Should a TPE option inputs be disabled or not according to option selection rules
             * @param  {Object}  option
             * @return {Boolean}
             */
            self.isTpeOptionDisabled = function isTpeOptionDisabled(option) {
                return (
                    (self.isTPEDevices === false &&
                        option.isTPEDevice === false &&
                        tpeService.isOptionIndependant(option) === false) ||
                    (self.isDefaultTPEDevice === false && _isPinpad(option.label))
                );
            };

            /**
             * Reset scanup options amount if there is no scanup device in the order
             */
            function _checkScanupOptions() {
                if (
                    orderService.isScanupDevicePresent(self.order.options) === false &&
                    (self.isTRAD() || self.isFLORAJET())
                ) {
                    for (var i = self.order.options.length - 1; i >= 0; i--) {
                        if (
                            self.order.options[i].optionType.code === 'SCANUP' &&
                            self.order.options[i].isScanupDevice === false
                        ) {
                            self.order.options[i].nbOptions = 0;
                            self.order.options.splice(i, 1);
                        }
                    }
                }
            }

            // L'option socle comptoire n'est sélectionnable que si l'option "dock de chargement" est déjà sélectionnée
            self.isSocleComptoireEnable = function isSocleComptoireEnable() {
                for (var i = self.order.options.length - 1; i >= 0; i--) {
                    if (self.order.options[i].code === 'DOCK-CHARGEMENT') {
                        return true;
                    }
                }
                return false;
            };

            /**
             * Reset the options from the BDC that are associated with the till pack
             * @param {String} tillType
             * @return {Void}
             */
            function _resetAssociatedOptions(tillType) {
                let optionDeleted = false;
                for (var i = self.order.options.length - 1; i >= 0; i--) {
                    if (self.order.options[i].tillType.code === tillType) {
                        for (var j = self.order.options[i].nbOptions; j > 0; j--) {
                            self.decreaseNumberOption(self.order.options[i]);
                        }
                        optionDeleted = true;
                    }
                }
                if (optionDeleted) {
                    Notification.warning('Les options associées au pack caisse ' + tillType + ' ont été supprimées.');
                }
            }

            /**
             * Reset the till accessories from the BDC
             * @param {String} tillType
             * @return {Void}
             */
            function _resetTillAccessories(tillType) {
                let optionDeleted = false;
                for (var i = self.order.options.length - 1; i >= 0; i--) {
                    if (self.order.options[i].optionType.code === 'ACCESSOIRE_CAISSE') {
                        for (var j = self.order.options[i].nbOptions; j > 0; j--) {
                            self.decreaseNumberOption(self.order.options[i]);
                        }
                        optionDeleted = true;
                    }
                }
                if (optionDeleted) {
                    Notification.warning('Les accessoires caisses ont été supprimées.');
                }
            }

            _initPrinterList();
            _initOptions();
            _isTPEDevices();
            _checkScanupOptions();

            self.disabledAddTillAccessoryCondition = function disabledAddTillAccessoryCondition(option) {
                switch (option.code) {
                    case 'POLE-SIMPLE-BT':
                    case 'POLE-DOUBLE-BT':
                        return !tillPackService.hasTillPack(self.order.tills, 'PREMIUM') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BT+') &&
                            !tillPackService.hasTillPack(self.order.tills, 'PREMIUM_RECONDITIONNE')
                    case 'POLE-SIMPLE-BS':
                        return !tillPackService.hasTillPack(self.order.tills, 'BG_PREMIUM') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BG');
                    case 'POLE-DOUBLE-BS':
                        return !tillPackService.hasTillPack(self.order.tills, 'BS_PREMIUM') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BG_PREMIUM') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BS') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BG');
                    case 'POLE-SIMPLE-BW':
                    case 'POLE-DOUBLE-BW':
                        return !tillPackService.hasTillPack(self.order.tills, 'BW_PREMIUM') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BW_ESSENTIEL') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BW');
                    case 'POLE-SIMPLE-BSW':
                    case 'POLE-DOUBLE-BSW':
                        return !tillPackService.hasTillPack(self.order.tills, 'BSW_PREMIUM') &&
                        !tillPackService.hasTillPack(self.order.tills, 'BSW_ESSENTIEL') &&
                        !tillPackService.hasTillPack(self.order.tills, 'BSW');
                    case 'AFFICHEUR-BC':
                        return !tillPackService.hasTillPack(self.order.tills, 'BC_ESSENTIEL') &&
                            !tillPackService.hasTillPack(self.order.tills, 'BC');
                    case 'ONDULEUR':
                        return !self.hasBsmartPack() && !self.hasBswiftPack() && !self.hasBtouchPack() && !self.hasBtouchRefurbishedPack() && !self.hasBgreenPack()
                            && !self.hasBwidePack() && !self.hasBCompactPack();

                    default:
                        return;
                }
            };

            /* =========================================================================================== */
            /*                                   GOODWILL GESTURES                                         */
            /* =========================================================================================== */
            self.isGoodwillGestures = !!self.order.goodwillGestures;
            self.selected = '';

            self.isTillPartExchange = false;
            self.isScanupPartExchange = false;
            self.isMDS = false;
            self.isRevenue = false;
            self.isWelcomeBonus = false;
            self.isDRVBudget = false;
            self.isTPE = false;
            self.isCashinServices = false;
            self.isServicesFestival = false;
            self.isMoneyTransferServices = false;
            self.isLaunchBimediaPay = false;
            self.isLaunchBBooster = false;
            self.isScanupServices = false;
            self.isEagle = false;
            self.isExceptionalOffer = false;
            self.isBgreenOffer = false;
            self.isQuickInstallOffer = false
            self.isClubBimediaOffer = false;

            self.tillPartExchange = goodwillGesturesService.getPartExchange('TILL', self.order);
            self.scanupPartExchange = goodwillGesturesService.getPartExchange('SCANUP', self.order);
            self.modalGGMDSRDS = 0;
            self.modalGGMDSDRV = 0;
            self.modalGGRevenue = null;
            self.welcomeBonus = null;
            self.welcomeBonusType = null;
            self.modalGGTPE = {};
            self.nbOfferedTPE = 0;
            self.modalGGDRVBudget = null;
            self.moneyTransferLevelSelected = null;
            self.segmentCode = null;

            /**
             * Initialize the screen with the order data
             */
            function _initGoodwillGestures() {
                _initGoodwillGesturesObjectIfNotExists();

                // Init lists consts from pricesService
                self.revenue = self.orderForm.revenues;
                self.segments = self.orderForm.segments;
                if (goodwillGesturesService.isWelcomeBonusConquestType(self.order)) {
                    self.welcomeBonuses = goodwillGesturesService.WELCOME_BONUSES.CONQUETE;
                } else if (goodwillGesturesService.isWelcomeBonusRenewalType(self.order)) {
                    self.welcomeBonuses = goodwillGesturesService.WELCOME_BONUSES.RENOUVELLEMENT;
                }

                // Till part exchange
                if (self.order.goodwillGestures.amount.tillPartExchange) {
                    self.isTillPartExchange = true;
                }

                // Scanup part exchange
                if (self.order.goodwillGestures.amount.scanupPartExchange) {
                    self.isScanupPartExchange = true;
                }

                // MDS
                if (self.order.goodwillGestures.mds.nbMDSRDS > 0 || self.order.goodwillGestures.mds.nbMDSDRV > 0) {
                    self.isMDS = true;
                    self.modalGGMDSRDS = self.order.goodwillGestures.mds.nbMDSRDS
                        ? self.order.goodwillGestures.mds.nbMDSRDS
                        : 0;
                    self.modalGGMDSDRV = self.order.goodwillGestures.mds.nbMDSDRV
                        ? self.order.goodwillGestures.mds.nbMDSDRV
                        : 0;
                }

                // Revenue
                if (self.order.goodwillGestures.revenue.rateId) {
                    self.isRevenue = self.order.goodwillGestures.revenue.typeCode.indexOf('GLADY') === -1;

                    // Check if the order already has a revenue (if rateId is null, it means that the order does not have a revenue)
                    var orderRevenueRateId = self.order.goodwillGestures.revenue.rateId
                        ? self.order.goodwillGestures.revenue.rateId
                        : null;

                    // If the order already has a revenue, then set the modalGGRevenue with this object, otherwise set it to null
                    self.modalGGRevenue = orderRevenueRateId ? self.order.goodwillGestures.revenue : null;
                }

                // Welcome bonus
                if (self.order.goodwillGestures.amount.welcomeBonus !== 0) {
                    self.isWelcomeBonus = true;
                    self.welcomeBonus = self.welcomeBonuses.values.find(function (bonus) {
                        if (goodwillGesturesService.isWelcomeBonusConquestType(self.order)) {
                            return bonus.value === self.order.goodwillGestures.amount.welcomeBonus / self.nbTills;
                        } else if (goodwillGesturesService.isWelcomeBonusRenewalType(self.order)) {
                            return (
                                bonus.value ===
                                self.order.goodwillGestures.amount.welcomeBonus /
                                self.nbTills /
                                self.order.contract.nbRenewals
                            );
                        }
                    });
                }

                // DRV
                if (self.order.drvBudget) {
                    self.isDRVBudget = true;

                    for (var j = 0; j < self.orderForm.drvBudget.length; j++) {
                        if (self.orderForm.drvBudget[j].id === self.order.drvBudget.id) {
                            self.order.drvBudget = self.orderForm.drvBudget[j];
                            break;
                        }
                    }

                    self.modalGGDRVBudget = self.order.drvBudget;
                }

                for (var i = 0; i < self.order.options.length; i++) {
                    // TPE
                    if (
                        self.order.options[i].isTPEDevice &&
                        (self.order.options[i].nbOffered > 0 || self.order.options[i].discount > 0)
                    ) {
                        self.modalGGTPE[self.order.options[i].id] = self.order.options[i].nbOffered
                            ? self.order.options[i].nbOffered
                            : 0;
                        self.nbOfferedTPE += self.order.options[i].nbOffered ? self.order.options[i].nbOffered : 0;
                        self.isTPE = true;
                    }

                    // MDS
                    if (
                        (self.order.options[i].optionType.code === 'SAV' ||
                            self.order.options[i].optionType.code === 'MAINTENANCE') &&
                        self.order.options[i].discount > 0
                    ) {
                        self.isMDS = true;
                    }
                }

                // Cashin Services
                if (self.order.goodwillGestures.amount.cashinServices) {
                    self.isCashinServices = true;
                }

                // Services Festival
                if (self.order.goodwillGestures.amount.servicesFestival) {
                    self.isServicesFestival = true;
                }

                // Launch Bimedia Pay
                if (self.order.goodwillGestures.amount.launchBimediaPay) {
                    pricesService.calculateLaunchBimediaPayTotal();
                    self.isLaunchBimediaPay = true;
                }

                // Launch B Booster
                if (self.order.goodwillGestures.amount.launchBBooster) {
                    self.goodwillGesturesService.calculateLaunchBBoosterTotal();
                    self.isLaunchBBooster = true;
                }

                // Money Transfer Services
                if (self.order.goodwillGestures.moneyTransfer.enabled) {
                    self.isMoneyTransferServices = true;
                    self.moneyTransferLevelSelected = self.order.goodwillGestures.moneyTransfer.levelId
                        ? self.goodwillGesturesService.getMoneyTransferLevelById(
                            self.order.goodwillGestures.moneyTransfer.levelId
                        )
                        : null;
                }

                // Services sur Scan'Up
                if (self.order.goodwillGestures.amount.scanupServices) {
                    self.isScanupServices = true;
                    self.isUpsOnly = self.isUPSOnly();
                }

                // Offre Eagle
                if (self.order.goodwillGestures.amount.eagle) {
                    self.isEagle = true;
                    self.segmentCode = self.order.goodwillGestures.segment.segmentCode;
                    self.updateEagle();
                }

                // offre Exceptionnelle
                if(self.order.goodwillGestures.amount.exceptionalOffer > 0) {
                    self.isExceptionalOffer = true;
                    self.order.isExceptionalOffer = true;
                    // _updatePrices();
                }

                // offre full premium
                if(self.order.goodwillGestures.amount.fullPremiumOffer > 0) {
                    self.isFullPremiumOffer = true;
                    self.order.isFullPremiumOffer = true;
                    // _updatePrices();
                }

                // offre Bgreen
                if (self.order.goodwillGestures.amount.bgreenOffer) {
                    self.isBgreenOffer = true;
                }

                // offre install rapide
                if(self.order.goodwillGestures.amount.quickInstall)
                    self.isQuickInstallOffer = true;

                // offre club Bimedia
                if(self.order.goodwillGestures.amount.clubBimedia && !self.order.goodwillGestures.generosity.renunciationClubBimedia) {
                    self.isClubBimediaOffer = true;
                }
            }

            /**
             * Init the goodwill gestures object for order model
             */
            function _initGoodwillGesturesObjectIfNotExists() {
                if (self.order.goodwillGestures) {
                    return;
                }

                self.order.goodwillGestures = orderService.getGoodwillGesturesObject();
                if (self.order.contract.scenarioType.code === 'EXTENSION') {
                    self.order.goodwillGestures.amount.clubBimedia = 150;
                }else if(self.order.contract.scenarioType.code !== 'PERIPHERIQUE'){
                    self.order.goodwillGestures.amount.clubBimedia = 300;
                }
            }

            /**
             * Remove the corresponding goodwill gesture
             */
            function _removeGG() {
                self.isGoodwillGestures = _getIsGG();
                _updatePrices();
            }


            /* === PART EXCHANGE === */
            self.tillPartExchangeKeys = Object.keys(self.orderForm.configuration.tillPartExchangeValues).reverse();
            self.scanupPartExchangeKeys = Object.keys(self.orderForm.configuration.scanupPartExchangeValues).reverse();

            /**
             * Is till part exchange available
             * Only for RENOUVELLEMENT and rental
             * @return {Boolean}
             */
            self.isTillPartExchangeAvailable = function () {
                return (
                    self.order.contract.scenarioType.code === 'RENOUVELLEMENT' &&
                    self.order.contract.contractType.code !== 'ACHAT'
                );
            };

            /**
             * Is scanup part exchange available
             * Only for RENOUVELLEMENT scenario, rental contract and a scanup added in the order
             * @return {Boolean}
             */
            self.isScanupPartExchangeAvailable = function () {
                return (
                    (self.order.contract.scenarioType.code === 'RENOUVELLEMENT' ||
                        self.order.contract.scenarioType.code === 'PERIPHERIQUE') &&
                    self.order.contract.contractType.code !== 'ACHAT' &&
                    orderService.isScanupDevicePresent(self.order.options) === true
                );
            };

            /**
             * @param  {String} type of partExchange 'TILL' or 'SCANUP'
             * Update the order model : part exchange
             */
            self.updatePartExchange = function updatePartExchange(type) {
                if (type === 'TILL') {
                    self.isTillPartExchange = true;
                    self.order.goodwillGestures.amount.tillPartExchange = self.tillPartExchange.partExchangeValue;
                    self.order.goodwillGestures.amount.tillPartExchangeId = self.tillPartExchange.partExchangeId;
                }

                if (type === 'SCANUP') {
                    self.isScanupPartExchange = true;
                    self.order.goodwillGestures.amount.scanupPartExchange = self.scanupPartExchange.partExchangeValue;
                    self.order.goodwillGestures.amount.scanupPartExchangeId = self.scanupPartExchange.partExchangeId;
                }
                self.isGoodwillGestures = true;
                _updatePrices();

                // There are no offered MDS for DRV with the part exchange
                if (self.isMDS) {
                    self.order.goodwillGestures.mds.nbMDSDRV = 0;
                    self.modalGGMDSDRV = 0;

                    _updateMDSLimit();
                }

                // Reinitialize TPE goodwill gesture
                self.isTPE = false;
                self.nbOfferedTPE = 0;
                for (var k = 0; k < self.orderForm.options.length; k++) {
                    if (self.orderForm.options[k].isTPEDevice) {
                        self.orderForm.options[k].nbOffered = 0;
                    }
                }
            };

            /**
             * Remove part exchange from order model
             * @param  {String} type of part exchange to remove (TILL or SCANUP)
             * @param {boolean} updatePrice
             */
            self.removePartExchange = function removePartExchange(type, updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                if (type === 'TILL') {
                    self.isTillPartExchange = false;
                    self.order.goodwillGestures.amount.tillPartExchange = 0;
                    self.order.goodwillGestures.amount.tillPartExchangeId = null;
                }

                if (type === 'SCANUP') {
                    self.isScanupPartExchange = false;
                    self.order.goodwillGestures.amount.scanupPartExchange = 0;
                    self.order.goodwillGestures.amount.scanupPartExchangeId = null;
                }

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /* === MDS === */
            $scope.$watch('orderCtrl.modalGGMDSRDS', function (newValue, oldValue) {
                if (oldValue === 0) {
                    return;
                }

                if (newValue !== '' && newValue !== oldValue) {
                    if (self.modalGGMDSRDS > self.getLimitMDSRDS()) {
                        Notification.error('Vous ne pouvez pas ajouter plus de ' + self.getLimitMDSRDS() + ' mois offerts');
                        return;
                    }
                    self.updateMDS();
                }
            });

            $scope.$watch('orderCtrl.modalGGMDSDRV', function (newValue, oldValue) {
                if (oldValue === 0) {
                    return;
                }

                if (newValue !== '' && newValue !== oldValue) {
                    if (self.modalGGMDSDRV > self.getLimitMDSDRV()) {
                        Notification.error('Vous ne pouvez pas ajouter plus de ' + self.getLimitMDSDRV() + ' mois offerts');
                        return;
                    }
                    self.updateMDS();
                }
            });
            /**
             * Get the limit of MDS RDS to offer
             * @return {int}]
             */
            self.getLimitMDSRDS = function getLimitMDSRDS() {
                if (self.isPartExchange) {
                    return self.nbTills === 1 ? 12 : self.orderForm.configuration.partExchangeMDSMax;
                }

                return self.orderForm.configuration.MDSRDSMax;
            };

            /**
             * Get the limit of MDS DRV to offer
             * @return {int}]
             */
            self.getLimitMDSDRV = function getLimitMDSDRV() {
                if (self.isPartExchange) {
                    return 0;
                }

                return (
                    (self.order.contract.contractType.code === 'LOC60'
                        ? self.orderForm.configuration.MDSTotalMaxRental60
                        : self.orderForm.configuration.MDSTotalMax) - self.orderForm.configuration.MDSRDSMax
                );
            };

            /* === PARTEXCHANGE === */
            self.getPartExchange = function getPartExchange(type, order) {
                order = order === undefined ? null : order;
                return goodwillGesturesService.getPartExchange(type, order);
            };

            self.getPartExchangeLabel = function getPartExchangeLabel(type, order) {
                order = order === undefined ? null : order;
                return self.getPartExchange(type, order).partExchangeLabel;
            };

            /* === REVENUE === */

            /**
             * Get the revenues depending on their type and validity date
             * Active revenues have no end date validity
             * @param type
             * @returns {*}
             */
            self.getRevenues = function getRevenues(type, order) {
                order = order === undefined ? null : order;
                return goodwillGesturesService.getRevenues(type, order);
            };

            self.hasInactiveRevenue = function hasInactiveRevenue(order, type) {
                if (order.isSigned) {
                    return false;
                } else {
                    return goodwillGesturesService.hasInactiveRevenue(order, type);
                }
            };

            let offreStarter = self.orderForm.revenueTypes.reduce((curr, offre) => {
                if(offre.code === 'STARTER') curr.push(offre);
                return curr;
            }, []);

            self.revenueTypeList = self.orderForm.revenueTypes.reduce((curr, offre) => {
                let rate = self.getRevenues(offre.code, self.order);
                if (rate.length) curr.push(offre);
                return curr;
            },[])/*.filter(offre => {
                if(!self.isSalesAdminLite) return offre.code.indexOf('MANAGEUR') === -1;
                return true;
            })*/;

            self.disableRevenueRate = function() {
                return self.revenueType.indexOf('MANAGEUR') !== -1 && !self.isSalesAdminLite;
            }


            // Get the order's revenue, or set ACCELERATEUR as the default value
            self.revenueType = self.order.goodwillGestures && self.order.goodwillGestures.revenue.typeCode
                ? self.order.goodwillGestures.revenue.typeCode
                : 'ACCELERATEUR';

            /**
             * Check if the revenue form can be displayed depending on a few conditions
             * @returns {boolean}
             */
            self.displayGGRevenueForm = function displayRevenueForm() {
                // Not for device scenario
                if (self.isDeviceScenario()) {
                    return false;
                }

                // Only for TABAC PRESSE market
                if (!(self.marketService.isTabacPresseMarket(self.order) || self.marketService.isAutreMarket(self.order))) {
                    return false;
                }

                // Not for NAP order type
                if (self.isNAP()) {
                    return false;
                }

                // Only for CONQUETE or RENOUVELLEMENT scenario
                if (
                    self.order.contract.scenarioType.code !== 'CONQUETE' &&
                    self.order.contract.scenarioType.code !== 'RENOUVELLEMENT'
                ) {
                    return false;
                }

                return true;
            };

            /**
             * Check if the part exchange form can be displayed
             * @returns {Boolean}
             */
            self.displayGGPartExchange = function displayGGPartExchange() {
                // return self.isTillPartExchangeAvailable() || self.isScanupPartExchangeAvailable();
                return moment(self.order.dateCreated).isBefore('2025-09-11') && (self.isTillPartExchangeAvailable() || self.isScanupPartExchangeAvailable());
            };

            /**
             * Check if the welcome bonus form can be displayed
             * welcome bonus form must be hidden when offer are not proposed
             * @returns {boolean}
             */
            self.displayGGWelcomeBonus = function displayGGWelcomeBonus() {
                const isWelcomeBonusDisabled = true;
                return isWelcomeBonusDisabled
                    ? false
                    : self.goodwillGesturesService.isWelcomeBonusRenewalType(self.order) ||
                    self.goodwillGesturesService.isWelcomeBonusConquestType(self.order);
            };

            /**
             * Check if the fidelity bonus can be displayed
             * fidelity bonus form must be hidden when offer are not proposed
             */
            self.displayFidelityBonus = function displayFidelityBonus() {
                const isFidelityBonusDisabled = false;
                return isFidelityBonusDisabled
                    ? false
                    : !self.isNAP() &&
                    self.order.contract.scenarioType.code === 'RENOUVELLEMENT' &&
                    self.order.contract.nbMonthsFidelity;
            };

            self.displayCalage = function () {
                const isCalageDisabled = false;
                return isCalageDisabled
                    ? false
                    : !self.isNAP() &&
                    (self.order.contract.scenarioType.code === 'RENOUVELLEMENT' || self.order.contract.scenarioType.code === 'CONQUETE' ) &&
                    self.order.contract.nbMonthsCalage;
            };

            self.displayFranchise = function () {
                const isFranchiseDisabled = false;
                return isFranchiseDisabled
                    ? false
                    : !self.isNAP() &&
                    (self.order.contract.scenarioType.code === 'CONQUETE' ) &&
                    self.order.contract.nbMonthsFranchise;
            };

            /**
             * Check if the cashin services offer can be displayed
             * cashin services form must be hidden when offer are not proposed
             */
            self.displayGGCashinServices = function displayGGCashinServices() {
                const isCashinServicesDisabled = true;

                if (isCashinServicesDisabled || self.isNAP() || !self.marketService.isTabacPresseMarket(self.order)) {
                    return false;
                }

                return true;
            };

            /**
             * Check if the services festival offer can be displayed
             * services festival form must be hidden when offer are not proposed
             */
            self.displayGGServicesFestival = function displayGGServicesFestival() {
                const isServicesFestivalDisabled = true;

                if (isServicesFestivalDisabled || self.isNAP() || !self.marketService.isTabacPresseMarket(self.order)) {
                    return false;
                }

                return true;
            };

            /**
             * Check if the Eagle offer can be displayed
             */
            self.displayGGEagle = function () {
                const isEagleDisabled = moment('2026-01-21').isBefore(self.order.dateCreated);
                return !(
                    isEagleDisabled ||
                    self.isNAP() ||
                    !self.marketService.isTabacPresseMarket(self.order)
                );
            };

            /**
             * Check if the Bimedia Pay offer can be displayed
             */
            self.displayGGLaunchBimediaPay = function displayGGLaunchBimediaPay() {
                const isLaunchBimediaPayDisabled = false;

                return !(
                    isLaunchBimediaPayDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order) &&
                        !self.marketService.isAutreMarket(self.order) &&
                        !self.marketService.isBoulangerieMarket(self.order) &&
                        !self.marketService.isFleuristeMarket(self.order))
                );
            };

            /**
             * Check if the B Booster offer can be displayed
             */
            self.displayGGLaunchBBooster = function displayGGLaunchBBooster() {
                const isLaunchBBoosterDisabled = true;

                return !(
                    isLaunchBBoosterDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order) &&
                        !self.marketService.isAutreMarket(self.order) &&
                        !self.marketService.isBoulangerieMarket(self.order) &&
                        !self.marketService.isFleuristeMarket(self.order))
                );
            };

            /**
             * Check if the moneytransfer services offer can be displayed
             * moneytransfer services form must be hidden when offer are not proposed
             */
            self.displayGGMoneyTransferServices = function displayGGMoneyTransferServices() {
                const isMoneyTransferServicesDisabled = false;
                return isMoneyTransferServicesDisabled
                    ? false
                    : !self.isNAP() &&
                    (self.marketService.isTabacPresseMarket(self.order) ||
                        self.marketService.isAutreMarket(self.order)) &&
                    self.order.contract.scenarioType.code !== 'PERIPHERIQUE' &&
                    self.order.contract.contractType.code !== 'LOC36';
            };

            self.displayGGScanupServices = function () {
                const isScanupServicesDisabled = false;

                return !(
                    isScanupServicesDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order) && !self.marketService.isAutreMarket(self.order))
                );
            };

            /**
             * Check if the Exceptional offer can be displayed
             */
            self.displayGGExceptionalOffer = function() {
                const isExceptionalOfferDisabled = !moment(self.order.dateCreated).isBefore('2025-01-12');

                return !(
                    isExceptionalOfferDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order))
                );
            };

            /**
             * Check if the Full Premium offer can be displayed
             */
            self.displayGGFullPremiumOffer = function() {
                const isFullPremiumOfferDisabled = false;

                return !(
                    isFullPremiumOfferDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order))
                );
            };

            /**
             * Check if the Exceptional offer can be displayed
             */
            self.displayGGBgreenOffer = function() {
                const isBgreenOfferDisabled = true;

                return !(
                    isBgreenOfferDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order))
                );
            };

            /**
             * Check if the QuickInstall offer can be displayed
             */
            self.displayGGQuickInstallOffer = function() {
                const isQuickInstallOfferDisabled = !moment(self.order.dateCreated).isAfter('2025-01-12');

                return !(
                    isQuickInstallOfferDisabled ||
                    self.isNAP() ||
                    (!self.marketService.isTabacPresseMarket(self.order))
                );
            };

            /**
             * Check if the Club Bimedia offer can be displayed
             */
            self.displayGGClubBimediaOffer = function() {
                const isClubBimediaOfferDisabled = !moment(self.order.dateCreated).isAfter('2026-01-21');

                return !(
                    isClubBimediaOfferDisabled ||
                    self.isNAP() ||
                    self.order.contract.scenarioType.code === 'PERIPHERIQUE'
                );
            };

            /**
             * Check if the goodwill gestures part can be displayed
             * If at least one part of the goodwill gestures can be displayed, return true
             * @returns {boolean}
             */
            self.displayGoodwillGestures = function () {
                if (
                    !(
                        (self.isTRAD() || self.isFLORAJET()) &&
                        !self.isOffer('webTill') &&
                        !self.marketService.isLadditionMarket(self.order)
                    )
                ) {
                    return false;
                }

                // Part exchange
                if (self.displayGGPartExchange()) {
                    return true;
                }
                // Revenues
                if (self.displayGGRevenueForm()) {
                    return true;
                }
                // Welcome bonus
                if (self.displayGGWelcomeBonus()) {
                    return true;
                }
                // Cashin Services
                if (self.displayGGCashinServices()) {
                    return true;
                }
                // Services Festival
                if (self.displayGGServicesFestival()) {
                    return true;
                }
                // MoneyTransfer Services
                if (self.displayGGMoneyTransferServices()) {
                    return true;
                }
                // Launch Bimedia Pay
                if (self.displayGGLaunchBimediaPay()) {
                    return true;
                }
                // Launch B Booster
                if (self.displayGGLaunchBBooster()) {
                    return true;
                }

                // Services sur scan'up
                if (self.displayGGScanupServices()) {
                    return true;
                }

                // Offre Eagle
                if (self.displayGGEagle()) {
                    return true;
                }

                if (self.displayGGExceptionalOffer()){
                    return true;
                }

                if (self.displayGGBgreenOffer()){
                    return true;
                }

                if (self.displayGGQuickInstallOffer()){
                    return true;
                }

                if (self.displayGGClubBimediaOffer()){
                    return true;
                }

                return false;
            };

            /**
             * Update the revenue GG in the order model
             */
            self.updateRevenue = function updateRevenue() {
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.revenue = self.modalGGRevenue;
                if(self.modalGGRevenue && self.modalGGRevenue.typeCode.indexOf('GLADY') === -1){
                    self.isRevenue = true;
                    _updatePrices();
                }

            };

            /**
             * Remove revenue from order model
             */
            self.removeRevenue = function removeRevenue(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isRevenue = false;
                self.order.goodwillGestures.revenue.rateId = null;
                self.order.goodwillGestures.revenue.rateValue = null;
                self.modalGGRevenue = null;
                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /* === PRIME DE BIENVENUE OU DE FIDELITE=== */

            /**
             * Update the welcomeBonus GG in the order model
             *
             */
            self.updateWelcomeBonus = function updateWelcomeBonus() {
                self.isGoodwillGestures = true;
                self.isWelcomeBonus = true;
                if (goodwillGesturesService.isWelcomeBonusConquestType(self.order)) {
                    self.order.goodwillGestures.amount.welcomeBonus = self.welcomeBonus.value * self.nbTills;
                } else if (goodwillGesturesService.isWelcomeBonusRenewalType(self.order)) {
                    self.order.goodwillGestures.amount.welcomeBonus =
                        self.welcomeBonus.value * self.nbTills * self.order.contract.nbRenewals;
                }

                _updatePrices();
            };

            /**
             * Remove welcomeBonus from order model
             */
            self.removeWelcomeBonus = function removeWelcomeBonus(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isWelcomeBonus = false;
                self.order.goodwillGestures.amount.welcomeBonus = 0;
                self.welcomeBonus = null;
                self.order.contract.nbRenewals = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /**
             * Find which welcome bonuses are allowed for the given order and its conditions
             * @param  {Number} index of the welcome bonus in the list from the service
             * @return {Boolean}
             */
            self.welcomeBonusAllowed = function welcomeBonusAllowed(index) {
                if (self.welcomeBonuses) {
                    // Only the lower half of bonuses are allowed for RDS
                    return parseInt(index) + 1 <= self.welcomeBonuses.values.length / 2;
                }
                return true;
            };

            self.updateNbRenewals = function updateNbRenewals() {
                if (self.order.contract.nbRenewals === undefined) {
                    Notification.warning('Le nombre de renouvellements doit être compris entre 0 et 3');
                }
                self.updateWelcomeBonus();
            };

            /* === SERVICES CASHIN === */

            self.activateCashinServices = function activateCashinServices() {
                self.removeServicesFestival();

                self.isCashinServices = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.amount.cashinServices = goodwillGesturesService.calculateCashinServiceTotal();

                _updatePrices();
            };

            self.removeCashinServices = function removeCashinServices(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isCashinServices = false;
                self.order.goodwillGestures.amount.cashinServices = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            function _resetCashinServices(tillPackCode) {
                if (
                    self.isCashinServices &&
                    (tillPackCode === 'BM' || tillPackCode === 'BM+' || tillPackCode === 'BS_ESSENTIEL' || tillPackCode === 'BS_PREMIUM'
                        || tillPackCode === 'BG_ESSENTIEL' || tillPackCode === 'BG_PREMIUM' || tillPackCode === 'BSW_ESSENTIEL' || tillPackCode === 'BSW_PREMIUM'
                        | tillPackCode === 'BW_ESSENTIEL' || tillPackCode === 'BW_PREMIUM' || tillPackCode === 'BC_ESSENTIEL')
                ) {
                    self.removeCashinServices();
                    Notification.warning("L'offre Services de cash-in a été désactivée.");
                }
            }

            self.activateCashinServicesCondition = function activateCashinServicesCondition() {
                if (
                    (self.hasBmoovPack() && !promotionService.hasBmoovPromotion(self.order.promotions)) ||
                    self.hasBsmartPack() || self.hasBgreenPack() || self.hasBswiftPack() ||  self.hasBwidePack() || self.hasBCompactPack()
                ) {
                    return true;
                }

                return false;
            };

            /* === SERVICES FESTIVAL === */

            self.activateServicesFestival = function activateServicesFestival() {
                self.removeCashinServices();

                self.isServicesFestival = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.amount.servicesFestival = goodwillGesturesService.calculateServiceFestivalTotal();

                _updatePrices();
            };

            self.removeServicesFestival = function removeServicesFestival(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isServicesFestival = false;
                self.order.goodwillGestures.amount.servicesFestival = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            function _resetServicesFestival(tillPackCode) {
                if (
                    self.isServicesFestival &&
                    (tillPackCode === 'BM' || tillPackCode === 'BM+' || tillPackCode === 'BS_ESSENTIEL' || tillPackCode === 'BS_PREMIUM'
                        || tillPackCode === 'BG_ESSENTIEL' || tillPackCode === 'BG_PREMIUM' || tillPackCode === 'BSW_ESSENTIEL' || tillPackCode === 'BSW_PREMIUM'
                        | tillPackCode === 'BW_ESSENTIEL' || tillPackCode === 'BW_PREMIUM' || tillPackCode === 'BC_ESSENTIEL')
                ) {
                    self.removeServicesFestival();
                    Notification.warning("L'offre Festival des services a été désactivée.");
                }
            }

            self.activateServicesFestivalCondition = function activateServicesFestivalCondition() {
                if (
                    (self.hasBmoovPack() && !promotionService.hasBmoovPromotion(self.order.promotions)) ||
                    self.hasBsmartPack() || self.hasBgreenPack() || self.hasBswiftPack() || self.hasBwidePack() || self.hasBCompactPack()
                ) {
                    return true;
                }

                return false;
            };

            /* === Eagle === */

            self.activateEagle = function () {
                self.isEagle = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.amount.eagle = goodwillGesturesService.calculateEagleTotal(self.order);
                _updatePrices();
            };

            self.activateEagleCondition = function () {
                const result = self.order.tills.filter(
                    till => (till.tillType.code !== 'BS_PREMIUM' && till.tillType.code !== 'BS_ESSENTIEL'
                        && till.tillType.code !== 'BG_PREMIUM' && till.tillType.code !== 'BG_ESSENTIEL' && till.tillType.code !== 'BM'
                    && till.tillType.code !== 'BM+' && till.tillType.code !== 'BSW_PREMIUM' && till.tillType.code !== 'BSW_ESSENTIEL'
                        && till.tillType.code !== 'BW_PREMIUM' && till.tillType.code !== 'BW_ESSENTIEL' && till.tillType.code !== 'BC_ESSENTIEL')
                );
                const options = self.order.options.filter(
                    opt => opt.code === 'LOGICIEL_CAISSE_TABAC' || opt.code === 'LOGICIEL_CAISSE_PRESSE'
                )
                let isSalesAdminLite = self.isExtensionScenario() || self.isRenouvellementScenario() ? !!userService.isSalesAdminLite($rootScope.user) : true;
                return result.length === 0 && options.length > 0 && isSalesAdminLite;
            };

            self.updateEagle = function () {
                const segment = _getSegment(self.segmentCode);
                self.order.goodwillGestures.segment.segmentTypeId = segment.id;
                self.order.goodwillGestures.segment.segmentCode = segment.code;
                self.order.goodwillGestures.segment.segmentLabel = segment.label;
                self.order.goodwillGestures.amount.eagle = goodwillGesturesService.calculateEagleTotal(self.order);
                _updatePrices();
            }

            function _getSegment(segmentCode) {
                const segment = self.segments.filter(
                    seg => (seg.code === segmentCode)
                );
                return segment[0];
            }

            function _resetEagle() {
                if (self.isEagle) {
                    self.removeEagle();
                    Notification.warning("L'offre Eagle a été désactivée.");
                }
            }

            self.removeEagle = function (updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isEagle = false;
                self.segmentCode = null;
                self.order.goodwillGestures.amount.eagle = 0;
                self.order.goodwillGestures.segment.segmentTypeId = null;
                self.order.goodwillGestures.segment.segmentCode = null;
                self.order.goodwillGestures.segment.segmentLabel = null;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /* === LAUNCH BIMEDIA PAY === */

            self.activateLaunchBimediaPay = function activateLaunchBimediaPay() {
                self.isLaunchBimediaPay = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.amount.launchBimediaPay = pricesService.calculateLaunchBimediaPayTotal(
                    self.order
                );
                // console.log(self.order);
                _updatePrices();
            };

            self.activateLaunchBimediaPayCondition = function activateLaunchBimediaPayCondition() {
                const result = self.order.options.filter(
                    option => option.code === 'SOFT-SCANUP-PAIEMENT' || option.code === 'SOFT-SCANUP-ENCAISSEMENT'
                );
                return result.length === 2;
            };

            function _resetLaunchBimediaPay() {
                if (self.isLaunchBimediaPay) {
                    self.removeLaunchBimediaPay();
                    Notification.warning("L'offre de lancement BimediaPay a été désactivée.");
                }
            }

            self.removeLaunchBimediaPay = function removeLaunchBimediaPay(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isLaunchBimediaPay = false;
                self.order.goodwillGestures.amount.launchBimediaPay = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /* === LAUNCH B BOOSTER === */

            self.activateLaunchBBooster = function activateLaunchBBooster() {
                self.isLaunchBBooster = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.amount.launchBBooster = goodwillGesturesService.calculateLaunchBBoosterTotal();

                _updatePrices();
            };

            self.removeLaunchBBooster = function removeLaunchBBooster(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isLaunchBBooster = false;
                self.order.goodwillGestures.amount.launchBBooster = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            function _resetLaunchBBooster() {
                if (self.isLaunchBBooster) {
                    self.removeLaunchBBooster();
                    Notification.warning("L'offre de Lancement B Booster a été désactivée.");
                }
            }

            self.activateLaunchBBoosterCondition = function activateServicesFestivalCondition() {
                return !!self.isOptionBBooster;
            };

            /* === SERVICES MONEYTRANSFER === */

            self.activateMoneyTransferServices = function activateMoneyTransferServices() {
                self.isMoneyTransferServices = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.moneyTransfer.enabled = true;

                _updatePrices();
            };

            self.updateMoneyTransferLevel = function updateMoneyTransferLevel() {
                if (!self.moneyTransferLevelSelected) {
                    self.order.goodwillGestures.moneyTransfer.levelId = null;
                } else {
                    self.order.goodwillGestures.moneyTransfer.levelId = self.moneyTransferLevelSelected.id;
                }

                _updatePrices();
            };

            self.removeMoneyTransferServices = function removeMoneyTransferServices(updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isMoneyTransferServices = false;
                self.moneyTransferLevelSelected = null;
                self.order.goodwillGestures.moneyTransfer.enabled = false;
                self.order.goodwillGestures.moneyTransfer.clubBimedia = false;
                self.order.goodwillGestures.moneyTransfer.levelId = null;
                self.order.goodwillGestures.amount.moneyTransferServices = 0;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            /* === Services sur Scanup === */

            self.activateScanupServices = function () {
                self.isScanupServices = true;
                self.isGoodwillGestures = true;
                self.order.goodwillGestures.scanupServices.isUPS = true;
                self.isUpsOnly = self.isUPSOnly();
                self.order.goodwillGestures.amount.scanupServices = goodwillGesturesService.calculateScanupServicesTotal(
                    self.order.contract.contractType.code, self.order.goodwillGestures.scanupServices
                );

                _updatePrices();
            };

            self.removeScanupServices = function (updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isScanupServices = false;
                self.order.goodwillGestures.amount.scanupServices = 0;
                self.order.goodwillGestures.scanupServices.isUPS = false;
                self.order.goodwillGestures.scanupServices.isBrinks = false;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            function _resetScanupServices() {
                if (self.isScanupServices) {
                    self.removeScanupServices();
                    Notification.warning("L'offre Services sur Scan'Up a été désactivée.");
                }
            }

            self.activateScanupServicesCondition = function () {
                return !!orderService.isScanupDevicePresent(self.order.options);
            };

            self.toggleUps = () => {
                self.order.goodwillGestures.scanupServices.isUPS = !self.order.goodwillGestures.scanupServices.isUPS
                self.isUpsOnly = self.isUPSOnly();
                self.order.goodwillGestures.amount.scanupServices = goodwillGesturesService.calculateScanupServicesTotal(
                    self.order.contract.contractType.code, self.order.goodwillGestures.scanupServices
                );
                self.isSaved = false;
            }

            self.toggleBrinks = () => {
                self.order.goodwillGestures.scanupServices.isBrinks = !self.order.goodwillGestures.scanupServices.isBrinks
                self.isUpsOnly = self.isUPSOnly();
                self.order.goodwillGestures.amount.scanupServices = goodwillGesturesService.calculateScanupServicesTotal(
                    self.order.contract.contractType.code, self.order.goodwillGestures.scanupServices
                );
                self.isSaved = false;
            }

            self.isUPSOnly = () => {
                return self.order.goodwillGestures.scanupServices.isUPS && !self.order.goodwillGestures.scanupServices.isBrinks
            }

            /* === Exceptional Offer === */

            self.activateExceptionalOffer = function () {
                self.isExceptionalOffer = true;
                self.isGoodwillGestures = true;
                self.order.isExceptionalOffer = true;
                self.order.promotions.map(promotion => {
                    if(promotion.selected && promotion.code !== 'B_SMART')
                        promotion.selected = false;
                });
                self.order.promotions = self.order.promotions.reduce((curr, promo) => {
                   if(promo.code === 'B_SMART')
                       curr.push(promo);
                   return curr;
                },[]);
                self.order.goodwillGestures.amount.exceptionalOffer = pricesService.calculateExceptionalOffer();
                let option = self.order.options.reduce((curr, opt) =>{
                    if(opt.optionType.code === 'MAINTENANCE')
                        curr = opt;
                    return curr;
                },{})
                self.getMaxDiscountAllowed(option);
                _updatePrices();
            };

            self.removeExceptionalOffer = function (updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isExceptionalOffer = false;
                self.order.goodwillGestures.amount.exceptionalOffer = 0;
                self.order.isExceptionalOffer = false;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            self.activateExceptionalOfferCondition = function () {
                return self.nbTills <= 3 && !tillPackService.isOnlyBGreenPack(self.order.tills)
                    && !tillPackService.isOnlyBWidePack(self.order.tills) && !self.isFullPremiumOffer
                    && pricesService.calculateExceptionalOffer(true) > 0;
            };

            /* === Full Premium Offer === */
            self.activateFullPremiumOffer = function () {
                self.isFullPremiumOffer = true;
                self.isGoodwillGestures = true;
                self.order.isFullPremiumOffer = true;
                self.order.goodwillGestures.amount.fullPremiumOffer = pricesService.calculateFullPremiumOffer();
                self.nbMonths = self.order.contract.contractType.code.split('LOC')[1];

                _updatePrices();
            };

            self.removeFullPremiumOffer = function (updatePrice) {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isFullPremiumOffer = false;
                self.order.goodwillGestures.amount.fullPremiumOffer = 0;
                self.order.isFullPremiumOffer = false;

                self.isGoodwillGestures = _getIsGG();

                if (updatePrice) {
                    _updatePrices();
                }
            };

            self.activateFullPremiumOfferCondition = function () {
                return self.nbScanup > 0 && (tillPackService.hasBgreenPack(self.order.tills) || tillPackService.hasBwidePack(self.order.tills)) && !self.isExceptionalOffer;
            };

            /* === BGreen Offer === */
            self.activateBgreenOffer = () => {
                self.isBgreenOffer = true;
                self.isGoodwillGestures = true;
                self.order.isBgreenOffer = true;
                self.order.goodwillGestures.amount.bgreenOffer = pricesService.calculateBgreenOffer();
                _updatePrices();
            };

            self.removeBgreenOffer = (updatePrice) => {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isBgreenOffer = false;
                self.isGoodwillGestures = _getIsGG();
                self.order.isBgreenOffer = false;
                self.order.goodwillGestures.amount.bgreenOffer = 0;
                if(updatePrice)
                    _updatePrices();
            }

            self.activateBgreenOfferCondition = function () {
                return tillPackService.hasBgreenPack(self.order.tills) && self.order.contract.contractType.code === 'LOC48';
            };

            /* === Quick install Offer === */
            self.activateQuickInstallOffer = () => {
                self.isQuickInstallOffer = true;
                self.isGoodwillGestures = true;
                self.order.isQuickInstallOffer = true;
                self.order.goodwillGestures.amount.quickInstall = pricesService.calculateQuickInstallOffer();
                _updatePrices();
            };

            self.removeQuickInstallOffer = (updatePrice) => {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isQuickInstallOffer = false;
                self.isGoodwillGestures = _getIsGG();
                self.order.isQuickInstallOffer = false;
                self.order.goodwillGestures.amount.quickInstall = 0;
                if(updatePrice)
                    _updatePrices();
                Notification.warning('L\'offre installation rapide a été désactivée.');
            }

            self.activateQuickInstallOfferCondition = function () {
                self.modules = self.order.options.reduce((curr, opt) => {
                    if (opt.code === 'LOGICIEL_CAISSE_TABAC' || opt.code === 'LOGICIEL_CAISSE_PRESSE') {
                        curr.push(opt.code);
                    }
                    return curr;
                }, []);
                const isOnlyBWide = tillPackService.isOnlyBWidePack(self.order.tills);
                const lastDate = moment(self.order.dateUpdated).add({days: 90}).endOf('month');
                let isDateOk = moment(self.order.dateCreated).isAfter('2025-04-21')
                    ? isOnlyBWide
                        ? self.modules.includes('LOGICIEL_CAISSE_TABAC') && self.modules.includes('LOGICIEL_CAISSE_PRESSE')
                        : self.modules.includes('LOGICIEL_CAISSE_TABAC') || self.modules.includes('LOGICIEL_CAISSE_PRESSE')
                    : self.modules.includes('LOGICIEL_CAISSE_TABAC') && self.modules.includes('LOGICIEL_CAISSE_PRESSE')
                return isDateOk && moment(self.order.dateInstallation).isBefore(lastDate);
            };

            self.getDateLimiteQuickInstallOffer = ()=> {
                return self.order.isSigned ?
                    moment(self.order.dateSignature).isBefore('2026-01-20') ?
                        moment(self.order.dateSignature).add({days: 60}).endOf('month').format('DD/MM/YYYY')
                        : moment(self.order.dateSignature).add({days: 90}).endOf('month').format('DD/MM/YYYY')
                    : moment(self.order.dateUpdated).add({days: 90}).endOf('month').format('DD/MM/YYYY');
            }

            /* === Club Bimedia Offer === */
            self.activateClubBimediaOffer = () => {
                self.isClubBimediaOffer = true;
                self.isGoodwillGestures = true;
                self.order.isClubBimediaOffer = true;
                self.order.goodwillGestures.amount.clubBimedia = self.order.contract.scenarioType.code === 'EXTENSION' ? 150 : 300;
                self.order.goodwillGestures.generosity.renunciationClubBimedia = false;
            };

            self.removeClubBimediaOffer = (updatePrice) => {
                updatePrice = updatePrice === undefined ? true : updatePrice;
                self.isClubBimediaOffer = false;
                self.isGoodwillGestures = _getIsGG();
                self.order.isClubBimediaOffer = false;
                self.order.goodwillGestures.amount.clubBimedia = self.order.contract.contractType.code === 'ACHAT' ? pricesService.priceConverter(7) : 7;
                self.order.goodwillGestures.generosity.renunciationClubBimedia = true;
                if(updatePrice)
                    _updatePrices();
                Notification.warning('Le client renonce au club Bimedia.');
            }

            self.activateClubBimediaOfferCondition = function () {
                let isDateOk = moment(self.order.dateCreated).isAfter('2026-01-21')
                return isDateOk && self.order.contract.scenarioType.code !== 'PERIPHERIQUE';
            };


            function _getIsGG() {
                let isRenunciationClubBimedia = self.order.goodwillGestures && self.order.goodwillGestures.generosity.renunciationClubBimedia ? self.order.goodwillGestures.generosity.renunciationClubBimedia : false
                var isGestures = [
                    self.isTillPartExchange,
                    self.isScanupPartExchange,
                    self.isMDS,
                    self.isRevenue,
                    self.isWelcomeBonus,
                    self.isDRVBudget,
                    self.isTPE,
                    self.isCashinServices,
                    self.isServicesFestival,
                    self.isMoneyTransferServices,
                    self.isLaunchBimediaPay,
                    self.isLaunchBBooster,
                    self.isScanupServices,
                    self.isEagle,
                    self.isExceptionalOffer,
                    self.isFullPremiumOffer,
                    self.isBgreenOffer,
                    self.isQuickInstallOffer,
                    self.isClubBimediaOffer,
                    isRenunciationClubBimedia
                ];
                return goodwillGesturesService.updateIsGG(isGestures);
            }

            _initGoodwillGestures();

            /* =========================================================================================== */
            /*                                       LADDITION                                             */
            /* =========================================================================================== */

            if (marketService.isLadditionMarket(self.order)) {
                if (self.order.laddition) {
                    // Init laddition options and total price to display it in the recap on order page
                    self.order.laddition.options = ladditionService.getLadditionOptions(self.order.options);
                    self.order.laddition.totalPrice = ladditionService.calculateLadditionPrice(self.order.laddition);
                }
            }

            /* =========================================================================================== */
            /*                                       BUSINESS                                             */
            /* =========================================================================================== */

            /**
             * is the order modifiable
             * @param  {Object} order
             * @return {Boolean}
             */
            // TRANSFERT_COMP règle à généraliser dans un service
            self.isModifiable = function isModifiable(order) {
                return (
                    order.isSigned === false &&
                    order.isLost === false &&
                    order.isAbandoned === false &&
                    self.isExtUser() === false &&
                    offerService.isOlderOffer(order) === false
                );
            };

            self.isExtUser = function isExtUser() {
                return userService.isExternalUser($rootScope.user);
            };

            function _getBusiness(id) {
                if (id !== null) {
                    id = typeof id === 'string' ? id : id.businessId;
                    walletService.getBusinessById(id).then(function (business) {
                        if(moment(business.moisSignature).endOf('month').isBefore(moment().endOf('month')) || business.moisSignature === null)
                            business.moisSignature = moment().endOf('month').format('YYYY-MM-DD');
                        self.order.business = business;
                        self.order.isBusinessLink = true;
                    });
                } else if (self.isModifiable(self.order)) {
                    walletService.getStoreBusinesses(self.order.client.id).then(function (businesses) {
                        let business = businesses.find(bus => bus.businessStatusId <= 2);
                        if(business){
                            if(moment(business.moisSignature).endOf('month').isBefore(moment().endOf('month')) || business.moisSignature === null)
                                business.moisSignature = moment().endOf('month').format('YYYY-MM-DD');
                        }else {
                            business = {
                                businessId: null,
                                businessStatusId: 1,
                                nombreCaisse: self.order.tills.length,
                                clientId: self.order.client.id,
                                commentaireCs: null,
                                commentaireRds: null,
                                dateFinContrat: self.order.client.dateFinContrat,
                                dateRdv: null,
                                managerRefId: $rootScope.user.parent ? $rootScope.user.parent.uid : $rootScope.user.parent,
                                moisRelance: null,
                                moisSignature: moment().endOf('month').format('YYYY-MM-DD'),
                                orderTypeId: self.order.orderType.id,
                                provenance: 'Création automatique BDC',
                                scenarioTypeId: self.order.contract.scenarioType.id,
                                storeActivityId: self.order.client.storeActivityId,
                                userIdRef: $rootScope.user.uid,
                                dateModificationStatus: null
                            };
                        }
                        self.order.business = business;
                        self.order.isBusinessLink = false;
                    });
                }
            }

            _getBusiness(self.order.business);

            /* =========================================================================================== */
            /*                                       GLOBALS                                               */
            /* =========================================================================================== */

            // Main log of order data
            $log.info('order', self.order);

            /**
             * Get contract type value
             * @type {Int}
             */
            self.getContractTypeValue = pricesService.getContractTypeValue;

            /**
             * Confirm the deletion of an element from the model
             */
            function _confirmRemove() {
                _removeTill();
                _removeWebTill();
                _removeGG();
            }

            /**
             * Is a rental contract type ?
             * @return {Boolean}
             */
            self.isRental = function isRental() {
                return self.order.contract.contractType.code !== 'ACHAT';
            };

            /**
             * Is the scanup contract a rental one ?
             * @return {Boolean}
             */
            self.isScanupRental = function isScanupRental() {
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].optionType.code === 'SCANUP') {
                        return self.order.options[i].contractType.code !== 'ACHAT';
                    }
                }
                return false;
            };
            /**
             * Is the flashup contract a rental one ?
             * @return {Boolean}
             */
            self.isFlashupRental = function isFlashupRental() {
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].optionType.code === 'FLASHUP') {
                        return self.order.options[i].contractType.code !== 'ACHAT';
                    }
                }
                return false;
            };

            /**
             * Is the catering support contract a rental one ?
             * @return {Boolean}
             */
            self.isCateringSupportRental = function () {
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].optionType.code === 'PRESTATION'
                        && self.isCateringSupport(self.order.options[i].code)) {
                        return self.order.options[i].contractType.code !== 'ACHAT';
                    }
                }
                return false;
            };

            /**
             * Is the install on site contract a rental one ?
             * @return {Boolean}
             */
            self.isInstallRental = function () {
                for (var i = 0; i < self.order.options.length; i++) {
                    if (self.order.options[i].optionType.code === 'PRESTATION'
                        && ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code)) {
                        return self.order.options[i].contractType.code !== 'ACHAT';
                    }
                }
                return false;
            };

            function _addPrestationInstallOption(option) {
                if (typeof option === 'undefined') {
                    self.orderForm.options
                        .filter(function (opt) {
                            return !opt.isDeleted;
                        })
                        .forEach(function (opt) {
                            if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD'].includes(opt.code) && opt.orderType.code === self.order.orderType.code
                                &&  self.order.contract.scenarioType.code !== 'PERIPHERIQUE')
                                option = opt;
                            if (['INSTALLATION-SITE', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(opt.code) && opt.orderType.code === self.order.orderType.code
                                &&  self.order.contract.scenarioType.code === 'PERIPHERIQUE')
                                option = opt;
                        });
                }
                option.selected = true;
                option.mandatory = true;
                option.nbOptions = 1;
                _addOption(option);
            }

            function _addReseauBConnectedNap(option) {
                if (typeof option === 'undefined') {
                    self.orderForm.options
                        .filter(function (opt) {
                            return !opt.isDeleted;
                        })
                        .forEach(function (opt) {
                            if (opt.code === 'RESEAU-BCONNECTED' && opt.orderType.code === self.order.orderType.code)
                                option = opt;
                        });
                }
                option.selected = true;
                option.mandatory = true;
                option.nbOptions = 1;
                _addOption(option);
            }

            function _unselectedOption(option) {
                if (typeof option !== 'undefined') {
                    option.nbOptions = 0;
                    option.selected = false;
                    option.mandatory = false;
                    _removeOption(option);
                }
            }

            function _addGestionScanup(option) {

                if (typeof option === 'undefined') {
                    self.orderForm.options
                        .filter(function (opt) {
                            return !opt.isDeleted;
                        })
                        .forEach(function (opt) {
                            if (opt.code === 'PACK-GESTION-SCANUP-BCONNECTED' && opt.orderType.code === self.order.orderType.code)
                                option = opt;
                        });
                }
                option.selected = true;
                option.mandatory = true;
                option.nbOptions = 1;
                _addOption(option);
            }


            /**
             * Is the client defined ?
             * @return {Boolean}
             */
            self.isClientDefined = function isClientDefined() {
                return self.order.client.id !== null;
            };

            /**
             * Filter an item to make them unavailable but still displayable after in reports if they are deleted
             * @method _filterAvailableItems
             * @param  {Object}           item present in orderForm (option, cashdrawer, till, accessories)
             * @param  {String}           type type of item given
             */
            function _filterAvailableItems(item, type) {
                item.isAvailable = !item.isDeleted;

                if (type === 'options' || type === 'cashDrawers') {
                    if (!item.isDeleted) {
                        item.isAvailable = marketService.isOptionInMarket(item, self.order.marketType.code);
                    }
                    if(item.refurbished && self.order.contract.contractType.code === 'LOC60')
                        item.isAvailable = false;
                }
                if (type === 'tills'){
                    if((item.tillType.code === 'FORFAIT' || item.tillType.code.split('_').indexOf('RECONDITIONNE') > -1)
                        && self.order.contract.contractType.code === 'LOC60') {
                        item.isAvailable = false;
                    }
                    // ouverture temporaire des B Green et B Smart à certaines personnes
                    if(item.isAvailable)
                        item.isAvailable = marketService.isTillInMarket(item, self.order.marketType.code, self.order.contract.contractType.code, self.orderForm.tillPrices)
                    if(['BS_PREMIUM', 'BG_PREMIUM'].includes(item.tillType.code) && ['fcatin332', 'faouadi384', 'mtacheau433', 'bsamain203', 'vcoulet391', 'mjouin351', 'gadler301'].indexOf($rootScope.user.uid) === -1) {
                        item.isAvailable = false;
                    }
                }

                return item.isAvailable;
            }

            /**
             * update isAvailable parameter for tills on adding or removing one, according to tillPack
             * @method _updateAvailableTills
             * @return
             */
            function _updateAvailableTills() {
                var tillPack = orderService.areTillsMixed(self.order.tills);
                if (offerService.isOlderOffer(self.order) === true) {
                    self.orderForm.tills.forEach(function (till) {
                        if (!till.isDeleted) {
                            till.isAvailable = tillPack.tillType.code
                                ? tillPack.tillType.code === till.tillType.code
                                : true;
                        }
                    });
                }
            }

            function _updateAvailablePromotions() {
                let promotions = self.order.promotions.filter(p => p.selected = true);
                for(let promotion of promotions){
                    if(self.disabledPromotionCondition(promotion))
                        _disablePromotion(promotion);
                }
            }

            /**
             * select default option for added till
             * @param addedTill
             * @private
             */
            function _selectDefaultOptions(addedTill) {
                let nbTillsByType = orderService.getNbTillsByTillType(self.order.tills);
                // if it's the first BT+ till for a NAP order
                if (addedTill.tillType.code === 'BT+' && nbTillsByType['BT+'] === 1 && self.isNAP()) {
                    // if there is no scan'up evolution, add one
                    if (!orderService.isScanupDevicePresent(self.order.options)) {
                        self.increaseNumberOption(self.getOptionFromCode('SCANUP-EVOLUTION'));
                        Notification.info("Scan'Up supplémentaire ajouté");
                    }
                }
            }

            /**
             * update isAvailable parameter for options if they should be included or cannot be added in the order (pack, market,...)
             * @method _updateAvailableOptions
             * @return
             */
            function _updateAvailableOptions() {
                self.orderForm.options
                    .filter(function (option) {
                        return !option.isDeleted;
                    })
                    .forEach(function (option) {
                        if (option.optionType.code === 'SAV') {
                            // Availability of sav options according to the offer and tillpack
                            option.isAvailable = option.isDefault
                                ? self.isBtouchPack()
                                : option.isService
                                    ? true
                                    : self.isBtouchPlusPack();
                        }

                        if (self.order.isSigned === false && self.order.isLost === false) {
                            // Include sav and maintenance options
                            if (tillPackService.is2017TillPack(self.order.tills, self.order.orderType.code)) {
                                if (
                                    (marketService.isTabacPresseMarket(self.order) ||
                                        marketService.isAutreMarket(self.order)) &&
                                    (option.optionType.code === 'MAINTENANCE' || option.optionType.code === 'SAV')
                                ) {
                                    option.selected = option.isAvailable;
                                    selectTillOption(option);
                                }
                            }

                            // Include mandatory software option
                            if (
                                offerService.isOlderOffer(self.order) === false &&
                                // (self.order.orderType.code === 'TRAD' || self.order.orderType.code === 'FLORAJET') &&
                                !self.isOffer('webTill')
                            ) {
                                if (
                                    option.optionType.code === 'LOGICIEL_CAISSE' &&
                                    option.isAvailable === true &&
                                    option.label === 'ENCAISSEMENT' &&
                                    self.order.orderType.code === option.orderType.code
                                    && self.order.contract.scenarioType.code !== 'PERIPHERIQUE'
                                ) {
                                    option.selected = true;
                                    option.isMandatory = true;
                                    selectTillOption(option);
                                }
                                // on ajoute B Booster d'office remisé à 100%
                                if (
                                    (option.code === 'B-BOOSTER' ||
                                    option.code === 'PACK-B-BOOSTER') &&
                                    option.isAvailable &&
                                    self.order.orderType.code === option.orderType.code
                                ) {
                                    option.selected = true;
                                    option.isMandatory = true;
                                    option.discount = 100;
                                    selectTillOption(option);
                                }
                            }

                            // Include mandatory software option for NAP
                            // if (
                            //     offerService.isOlderOffer(self.order) === false &&
                            //     self.order.orderType.code === 'NAP' &&
                            //     option.code === 'LOGICIEL_CAISSE_PRESSE'  &&
                            //     option.isAvailable === true &&
                            //     self.order.orderType.code === option.orderType.code
                            // ) {
                            //     if(self.order.contract.scenarioType.code !== 'PERIPHERIQUE') {
                            //         option.selected = true;
                            //         option.isMandatory = false;
                            //         selectTillOption(option);
                            //     }
                            // }

                            // The accessories tills option for NAP must only be available with B-Moov tills
                            // if (self.order.orderType.code === 'NAP' && option.optionType.code === 'ACCESSOIRE_CAISSE') {
                            //     if (self.hasBmoovPack()) {
                            //         option.isAvailable = true;
                            //     } else {
                            //         option.isAvailable = false;
                            //     }
                            // }
                        }
                    });
            }

            $scope.$watch('orderCtrl.exceptionalOffer', function(newValue, oldValue) {
                if(newValue === false)
                    self.removeExceptionalOffer();
            });

            /**
             * Update prices
             */
            function _updatePrices() {
                self.exceptionalOffer = self.nbTills < 4 ? pricesService.calculateExceptionalOffer(true) > 0 : false;
                pricesService.updateOrderPrices();
                unitBonusService.updateOrderUnitBonus();
                if(self.order.promotions.find(promotion => promotion.code === 'B_TOUCH'))
                    if(!self.canEnableBTPromotion())
                        _resetAssociatedPromotion('BT+');
                self.isSaved = false;
            }

            self.getAmountFinanced = () => {
                return pricesService.getAmountFinanced();
            }

            /**
             * Is there the same number of Tills and cash drawers ?
             * @method _isCorrectNbTillsAndCashDrawers
             * @return {Boolean}
             */
            function _isCorrectNbTillsAndCashDrawers() {
                var nbCashDrawers = 0;

                for (var k = 0; k < self.order.cashDrawers.length; k++) {
                    nbCashDrawers += self.order.cashDrawers[k].nbCashDrawers;
                }

                return self.nbTills === nbCashDrawers;
            }

            /**
             * Check scanup installation amount compared to scanup amount and set the scanupinstallation attribute.
             * @method _isCorrectScanupInstallationAmount
             * @return {Boolean}
             */
            function _isCorrectScanupInstallationAmount() {
                var scanupInstallOption = self.order.options.find(function (option) {
                    return option.id === 48;
                });

                if (scanupInstallOption && orderService.isScanupDevicePresent(self.order.options) === false) {
                    return false;
                }

                self.order.scanupInstallation = !!scanupInstallOption;
                return true;
            }

            /**
             * Check function to enforce selection of 1 and only 1 mandatory option with a given optionType
             * @param       {String}  optionType
             * @return      {Boolean}
             */
            function _isMandatoryOptionSelected(optionType) {
                var packOptions = self.order.options.filter(function (option) {
                    return option.optionType.code === optionType && option.selected;
                });
                var verification = {
                    check: false,
                    amount: packOptions.length
                };
                if (packOptions.length === 1) {
                    verification.check = true;
                }
                return verification;
            }

            /**
             *
             * @returns {boolean}
             * @private
             */
            function _checkBeforeSave () {
                if(moment(self.order.dateCreated).isBefore(moment('2023-01-01'))){
                    return true;
                }
                // Verifications conditions before saving an order
                if (!self.order.client.storeActivityId) {
                    Notification.error("Le point de vente ne possède pas d'activité");
                    return false;
                }

                // Maintenance and gestion pack check are only necessary when there are tills in the order
                if (self.isDeviceScenario() === false && self.nbTills > 0) {
                    if (
                        (self.order.orderType.code === 'TRAD' || self.order.orderType.code === 'FLORAJET') &&
                        self.order.offer.code !== 'webTill' &&
                        offerService.isOlderOffer(self.order) === false
                    ) {
                        var verification = _isMandatoryOptionSelected('MAINTENANCE');
                        if (verification.check === false) {
                            var checkMessage = 'Erreur pack maintenance: ';
                            if (verification.amount === 0) {
                                checkMessage += " vous n'avez pas sélectionné de pack.";
                            }
                            if (verification.amount > 1) {
                                checkMessage += " vous avez sélectionné plus d'un seul pack.";
                            }
                            Notification.error(checkMessage);
                            return false;
                        }
                        var verification = _isMandatoryOptionSelected('GESTION');
                        if (verification.check === false) {
                            var checkMessage = 'Erreur pack gestion et accompagnement: ';
                            if (verification.amount === 0) {
                                checkMessage += " vous n'avez pas sélectionné de pack.";
                            }
                            if (verification.amount > 1) {
                                checkMessage += " vous avez sélectionné plus d'un seul pack.";
                            }
                            Notification.error(checkMessage);
                            return false;
                        }
                    }
                    if (
                        (self.order.orderType.code === 'TRAD' || self.order.orderType.code === 'FLORAJET' || self.order.orderType.code === 'NAP') &&
                        self.order.offer.code !== 'webTill' &&
                        offerService.isOlderOffer(self.order) === false
                    ) {
                        if (['TABAC', 'PRESSE', 'TABACPRESSE'].indexOf(self.order.marketType.code) !== -1) {
                            let software = self.order.options.reduce((curr, opt) => {
                                if (['TABAC', 'PRESSE'].indexOf(opt.label) !== -1)
                                    curr.push(opt);
                                return curr;
                            }, []);
                            if (software.length === 0 && !self.order.options.find(opt => opt.label === 'LIBRAIRIE')) {
                                Notification.error('Vous devez sélectionner au minimum le logiciel TABAC ou le logiciel PRESSE');
                                return false;
                            }
                        }
                    }
                }

                if (self.isDeviceScenario() === true && self.bConnectedIsAvailable()) {
                    if (
                        (self.order.orderType.code === 'TRAD' || self.order.orderType.code === 'FLORAJET') &&
                        self.order.offer.code !== 'webTill' &&
                        offerService.isOlderOffer(self.order) === false
                    ) {
                        var verification = _isMandatoryOptionSelected('GESTION_SCANUP');
                        if (verification.check === false) {
                            var checkMessage = 'Erreur pack gestion et accompagnement: ';
                            if (verification.amount === 0) {
                                checkMessage += " vous n'avez pas sélectionné de pack.";
                            }
                            if (verification.amount > 1) {
                                checkMessage += " vous avez sélectionné plus d'un seul pack.";
                            }
                            Notification.error(checkMessage);
                            return false;
                        }
                    }
                }

                let softsScanup = self.order.options.reduce((curr, opt) => {
                    if (opt.code === 'SOFT-SCANUP-TABAC' || opt.code === 'SOFT-SCANUP-PRESSE' || opt.code === 'SOFT-SCANUP-TABACPRESSE'
                        || opt.code === 'SOFT-SCANUP-PRODUIT') {
                        curr.push(opt.code);
                    }
                    return curr;
                }, []);

                if (self.nbScanup > 0 && softsScanup.length === 0 && !self.isNAP) {
                    checkMessage = " Vous devez sélectionner au moins 1 soft scan'Up parmi le soft tabac, le soft presse ou le soft produit.";
                    Notification.error(checkMessage);
                    return false;
                }

                if (!_isCorrectNbTillsAndCashDrawers()) {
                    Notification.warning('Le nombre de caisses est différent du nombre de tiroirs caisses');
                }

                if (!_isCorrectScanupInstallationAmount()) {
                    Notification.warning("Une installation Scan'Up a été ajoutée sans aucune Scan'Up dans la commande");
                }

                if (
                    self.order.goodwillGestures.moneyTransfer.enabled &&
                    !self.order.goodwillGestures.moneyTransfer.levelId
                ) {
                    Notification.warning(
                        "L'offre transfert d'argent a été activé mais aucun palier de transactions n'a été sélectionné"
                    );
                }
                if (self.isScanupServices &&
                    !self.order.goodwillGestures.scanupServices.isUPS &&
                    !self.order.goodwillGestures.scanupServices.isBrinks
                ) {
                    Notification.error('L\'offre Services sur Scan\'Up est active. Vous devez sélectionner au minimum 1 service');
                    return false;
                }

                if (self.isEagle && !self.order.goodwillGestures.segment.segmentCode) {
                    Notification.error('Vous devez sélectionner un segment pour l\'offre Eagle');
                    return false;
                }

                let prestaInstall = self.order.options.find(opt => ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(opt.code) && opt.selected);
                if(!self.isDeviceScenario() && !prestaInstall){
                    Notification.error('Vous devez sélectionner un type d\'installation sur site');
                    return false;
                }

                return true;

            }

            /**
             * Save order
             */
            self.saveOrder = function (check) {
                check = check === undefined ? false : check;
                let isOk = true;
                if (check)
                    isOk = _checkBeforeSave();
                if (isOk) {
                    if (!self.order.dateCreated) {
                        self.order.dateCreated = moment().toISOString();
                    }

                    if (!$rootScope.online) {
                        self.order.dateUpdated = moment().toISOString();
                    }

                    self.order.isDeloitte = self.isDeloitteAvailable();
                    self.order.isMPDV = self.isMPDV();
                    self.order.business.nombreCaisse = self.nbTills;
                    self.order.business.scenarioTypeId = self.order.contract.scenarioType.id;
                    self.order.business.orderTypeId = self.order.orderType.id;
                    orderService
                        .saveOrder(self.isGoodwillGestures, self.order)
                        .then(function (res) {
                            self.order.id = res.order.id;
                            self.order.business = res.order.business
                            self.order.isBusinessLink = !!res.order.business.businessId;
                            $log.info('order', self.order);
                            Notification.success('Le bon de commande a été enregistré');
                            self.isSaved = true;
                        })
                        .catch(function (err) {
                            $log.error(err);
                            // $log.error(err.data.description);
                            Notification.error('Une erreur est survenue : ' + err.data.message);
                        })
                        .finally(function () {
                            _initGoodwillGesturesObjectIfNotExists();
                        });
                }

            };

            /**
             * Is the order eligible to Deloitte
             * @return {Boolean}
             */
            self.isDeloitteAvailable = function isDeloitteAvailable() {
                return goodwillGesturesService.isDeloitteAvailable(self.order);
            };

            self.isMPDV = function () {
                var optionsMPDV = self.order.options.filter(function (option) {
                    return _isOptionMPDV(option);
                });

                return optionsMPDV.length > 0;
            };

            self.getDateInstallation = function getDateInstallation() {
                return self.order.dateInstallation
                    ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                    : 'NC';
            };

            /* Check which boulangerie Pack is selected */
            self.isBoulangeriePack = function isBoulangeriePack(packType) {
                return boulangerieService.getPack(self.order)
                    ? boulangerieService.check[packType](boulangerieService.getPack(self.order))
                    : false;
            };

            self.openMainReport = function openMainReport(dest) {
                if(_checkBeforeSave()){
                    if (dest === 'NAP') {
                        reportRoutingService.openReport('NAP', self.order);
                    }else if (dest === 'NAPOLD'){
                        reportRoutingService.openReport('NAPOLD', self.order);
                    }else if (marketService.isLadditionMarket(self.order)) {
                        reportRoutingService.openReport('LADDITION', self.order);
                    } else if (marketService.isFleuristeMarket(self.order)) {
                        reportRoutingService.openReport('FLEURISTE', self.order);
                    } else {
                        reportRoutingService.openReport('TABACPRESSE', self.order);
                    }
                }

            };

            /* =========================================================================================== */
            /*                                        MODALS                                               */
            /* =========================================================================================== */

            /**
             * Open the till info modal
             * @param  {String} size
             */
            self.openModalTillInfo = function (till) {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'tillInfoModal.html',
                    controller: 'FormTillInfoCtrl',
                    controllerAs: 'formTillInfoCtrl',
                    resolve: {
                        till: function () {
                            return till;
                        }
                    }
                });
            };

            /**
             * Open the till info modal
             * @param webtill
             */
            self.openModalWebTillInfo = function () {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'webTillInfoModal.html',
                    controller: 'FormWebTillInfoCtrl',
                    controllerAs: 'formWebTillInfoCtrl',
                    resolve: {
                        webTillPackage: function () {
                            return self.order.package;
                        }
                    }
                });
            };

            /**
             * Open the cash drawer info modal
             * @param  {String} size
             */
            self.openModalCashDrawerInfo = function (cashDrawer) {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'cashDrawerInfoModal.html',
                    controller: 'FormCashDrawerInfoCtrl',
                    controllerAs: 'formCashDrawerInfoCtrl',
                    resolve: {
                        cashDrawer: function () {
                            return cashDrawer;
                        }
                    }
                });
            };

            let openAskPistolGripModal = function(){
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'pistolGripOrder.html',
                    controller: 'PistolGripOrderCtrl',
                    controllerAs: 'pistolGripOrderCtrl',
                    size: 'lg',
                    resolve: {}
                });
                modal.result.then(function (obj) {
                    Object.keys(obj).forEach(function (key) {
                        if (obj[key]) {
                            if(key === 'isPistol')
                                self.increaseNumberOption(optionPistolGrip);
                            if(key === 'isEncaissement')
                                self.increaseNumberOption(optionSoftScanupEncaissement);
                        }
                    });
                });
            };

            /**
             * Open the order web tills modal
             */
            self.openModalOrderWebTills = function () {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'modalOrderWebTills.html',
                    controller: 'FormOrderWebTillsCtrl',
                    controllerAs: 'formOrderWebTillsCtrl',
                    size: 'lg',
                    resolve: {
                        webTillPackages: function () {
                            return self.orderForm.packages;
                        }
                    }
                });
                modal.result.then(function () {
                    _addWebTillPackages();
                });
            };

            /**
             * Open the client modal
             * @param  {String} size
             */
            self.openModalClient = function (size) {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'createUpdateClient.html', // modal/client.html
                    controller: 'CreateUpdateClientCtrl',
                    controllerAs: 'createUpdateClientCtrl',
                    size: size,
                    resolve: {
                        order: function () {
                            self.order.fromOrder = true;
                            return self.order;
                        }
                    }
                });

                modal.result.then(function () {
                    _updatePrices();
                });
            };

            /**
             * Open the order contract modal
             */
            self.openModalOrderContract = function () {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'modalOrderContract.html',
                    controller: 'FormOrderContractCtrl',
                    controllerAs: 'formOrderContractCtrl',
                    size: 'lg',
                    resolve: {
                        order: function () {
                            return self.order;
                        }
                    }
                });

                modal.result.then(function (result) {
                    self.options = _getOptions();
                    self.cashDrawers = []
                    _initCashDrawersList();
                    _initCashDrawersOrderValues();
                    if (self.order.marketType.code === 'FLEURISTE') {
                        // If the offer type has changed, delete all the options
                        if (result.oldOfferCode !== result.newOfferCode) {
                            self.order.options = [];
                            for (let option of self.options) {
                                option.nbOptions = 0;
                                option.selected = false;
                            }

                            // Reset some fields depending on the new offer
                            if (result.newOfferCode === 'webTill') {
                                self.order.contract.nbMonths = 0;
                                self.order.contract.monthlyPayment = 0;
                                self.order.contract.nbMonthsFidelity = 0;
                                self.order.contract.monthlyPaymentFidelity = 0;
                                self.order.tills = [];
                                self.nbTills = 0;
                                self.order.cashDrawers = [];
                                self.addedTills = [];
                                for (let id in self.nbCashDrawersById) {
                                    self.nbCashDrawersById[id].nbCashDrawers = 0;
                                }
                            } else if (result.newOfferCode === 'materialTill') {
                                self.isTills = self.isContractDefined && self.order.tills.length;
                                self.order.package = [];
                                self.isSelectedFormule = false;
                            }
                        }
                    }

                    self.isContractDefined = true;
                    self.limitTills = _updateTillsLimit();
                    self.order.scanupContractType.code = self.order.contract.contractType.code;
                    self.order.scanupContractType.label = self.order.contract.contractType.label;
                    self.order.scanupContractType.id = self.order.contract.contractType.id;
                    self.order.flashupContractType.code = 'ACHAT'; // Seulement disponible à l'achat pour l'instant
                    self.order.installContractType.code = self.order.contract.contractType.code;
                    self.order.installContractType.label = self.order.contract.contractType.code;
                    self.order.installContractType.id = self.order.contract.contractType.id;
                    self.order.cateringSupportContractType.code = self.order.contract.contractType.code;
                    self.order.cateringSupportContractType.label = self.order.contract.contractType.label;
                    self.order.cateringSupportContractType.id = self.order.contract.contractType.id;

                    if(['LOC60', 'ACHAT'].indexOf(self.order.contract.contractType.code) > -1){
                        self.order.contract.nbMonthsFidelity = 0;
                        self.order.contract.monthlyPaymentFidelity = 0;
                    }

                    for (var i = 0; i < self.order.options.length; i++) {
                        if (self.order.options[i].optionType.code === 'SCANUP') {
                            if (self.order.options[i].code !== 'SOFT-SCANUP-PAIEMENT') {
                                self.order.options[i].contractType = self.order.scanupContractType;
                            } else {
                                self.order.options[i].contractType = {id: 6, label: 'Sans engagement', code: 'SANSENG'};
                            }
                        }
                        if (self.order.options[i].optionType.code === 'FLASHUP') {
                            self.order.options[i].contractType = self.order.flashupContractType;
                        }

                        if (self.order.options[i].optionType.code === 'PRESTATION') {
                            if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                                self.order.options[i].contractType = self.order.installContractType;
                            if(self.isCateringSupport(self.order.options[i].code)){
                                self.order.options[i].contractType = self.order.cateringSupportContractType;
                            }
                        }
                    }

                    // on ajoute ou supprime l'installation sur site en fonction du contrat
                    let installOption, gestionScanup, gestion, encaissement , reseauBConnected, presse;
                    for (let i = 0; i < self.order.options.length; i++) {
                        if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                            installOption = self.order.options[i];
                        if (self.order.options[i].code === 'PACK-GESTION-SCANUP-BCONNECTED')
                            gestionScanup = self.order.options[i];
                        if (self.order.options[i].code === 'PACK-GESTION-PREMIUM-BCONNECTED' || self.order.options[i].code === 'PACK-GESTION-ESSENTIEL-BCONNECTED')
                            gestion = self.order.options[i];
                        if (self.order.options[i].code === 'LOGICIEL_CAISSE_ENCAISSEMENT')
                            encaissement = self.order.options[i];
                        if (self.order.options[i].code === 'LOGICIEL_CAISSE_PRESSE')
                            presse = self.order.options[i];
                        if(self.order.options[i].code === 'RESEAU-BCONNECTED')
                            reseauBConnected = self.order.options[i];
                    }


                    if ((self.isRenouvellementScenario() || self.isConqueteScenario() || self.isDeviceScenario() || self.isExtensionScenario())
                        && self.bConnectedIsAvailable() && self.prestationIsAvailable()) {
                        _addPrestationInstallOption(installOption);
                        if(self.isNAP()) {
                            _addReseauBConnectedNap(reseauBConnected);
                            _addOption(presse);
                        }
                    }

                    if (self.isDeviceScenario()) {
                        if (self.bConnectedIsAvailable() && !self.isNAP())
                            _addGestionScanup(gestionScanup);
                        _unselectedOption(gestion);
                        _unselectedOption(encaissement);
                    } else {
                        _unselectedOption(gestionScanup);
                    }

                    if (self.order.goodwillGestures && result.hasContractScenarioChanged === true) {
                        self.removeRevenue(false);
                        self.removeWelcomeBonus(false);
                        self.removePartExchange('TILL', false);
                        self.removePartExchange('SCANUP', false);
                        self.removeCashinServices(false);
                        self.removeServicesFestival(false);
                        self.removeMoneyTransferServices(false);
                        self.removeLaunchBimediaPay(false);
                        self.removeLaunchBBooster(false);
                        self.removeScanupServices(false);
                        self.removeEagle(false);
                        self.removeExceptionalOffer(false);
                        self.removeBgreenOffer(false);
                        self.removeQuickInstallOffer(false);
                        self.activateClubBimediaOffer();

                        if (self.isDeviceScenario()) {
                            self.order.bConnected = 'PAW';
                            self.order.goodwillGestures.revenue.rateId = null;
                            self.order.goodwillGestures.mds.nbMDSRDS = 0;
                            self.order.goodwillGestures.mds.nbMDSDRV = 0;
                            self.order.goodwillGestures.moneyTransfer.enabled = false;
                            self.order.goodwillGestures.amount.revenue = 0;
                            self.order.goodwillGestures.amount.mds = 0;
                            self.order.goodwillGestures.amount.tillPartExchange = 0;
                            self.order.goodwillGestures.amount.welcomeBonus = 0;
                            self.order.goodwillGestures.amount.scanupPartExchange = 0;
                            self.order.goodwillGestures.amount.cashinServices = 0;
                            self.order.goodwillGestures.amount.servicesFestival = 0;
                            self.order.goodwillGestures.amount.moneyTransferServices = 0;
                            self.order.goodwillGestures.amount.launchBimediaPay = 0;
                            self.order.goodwillGestures.amount.launchBBooster = 0;
                            self.order.goodwillGestures.amount.scanupServices = 0;
                            self.order.goodwillGestures.amount.eagle = 0;
                            self.order.goodwillGestures.amount.exceptionalOffer = 0;
                            self.order.goodwillGestures.amount.bgreenOffer = 0;
                            self.order.goodwillGestures.amount.quickInstall = 0;
                            self.order.goodwillGestures.amount.clubBimedia = 0;
                            self.order.goodwillGestures.generosity.renunciationClubBimedia = false;

                            self.isMDS = false;
                            self.isTillPartExchange = false;
                            self.isScanupPartExchange = false;
                            self.isLaunchBimediaPay = false;
                            self.isLaunchBBooster = false;
                            self.isScanupServices = false;
                            self.isExceptionalOffer = false;
                            self.isBgreenOffer = false;
                            self.isQuickInstallOffer = false;
                        }

                        if (goodwillGesturesService.isWelcomeBonusConquestType(self.order)) {
                            self.welcomeBonuses = goodwillGesturesService.WELCOME_BONUSES.CONQUETE;
                        } else if (goodwillGesturesService.isWelcomeBonusRenewalType(self.order)) {
                            self.welcomeBonuses = goodwillGesturesService.WELCOME_BONUSES.RENOUVELLEMENT;
                        }
                        Notification.info('Cas de figure du contrat modifié: remise à zéro des offres commerciales.');
                        self.isGoodwillGestures = _getIsGG();
                    } else if (
                        self.order.goodwillGestures.moneyTransfer.enabled &&
                        result.hasContractContractChanged === true &&
                        self.order.contract.contractType.code === 'LOC36'
                    ) {
                        self.removeMoneyTransferServices(false);
                        Notification.info(
                            "L'offre Transfert d'argent n'est pas compatible avec le type de contrat : l'offre a été désactivée"
                        );
                        self.isGoodwillGestures = _getIsGG();
                    }
                    if (self.order.goodwillGestures && result.hasContractContractChanged === true && self.isScanupServices) {
                        self.order.goodwillGestures.amount.scanupServices = goodwillGesturesService.calculateScanupServicesTotal(
                            self.order.contract.contractType.code, self.order.goodwillGestures.scanupServices
                        );
                    }
                    if(self.isBgreenOffer && result.hasContractContractChanged === true &&
                        self.order.contract.contractType.code !== 'LOC48'){
                        self.removeBgreenOffer(false);
                    }
                    if(self.isQuickInstallOffer && result.removeQuickInstallOffer)
                        self.removeQuickInstallOffer(false);

                    _updatePrices();

                    self.saveOrder();
                });
            };


            /**
             * Open the order tills modal
             */
            self.openModalOrderTills = function () {
                if (_checkTillsLimit()) {
                    Notification.error('Vous ne pouvez pas ajouter plus de caisses');
                    return;
                }

                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'modalOrderTills.html',
                    controller: 'FormOrderTillsCtrl',
                    controllerAs: 'formOrderTillsCtrl',
                    size: 'lg',
                    resolve: {
                        nbTillsById: function () {
                            return _nbTillsById;
                        },
                        tills: function () {
                            return _getTills();
                        },
                        tillsLimit: function () {
                            return {
                                limit: self.limitTills,
                                nbTills: self.nbTills
                            };
                        },
                        order: function () {
                            return self.order;
                        }
                    }
                });

                modal.result.then(function () {
                    _addTills();
                    self.limitTills = _updateTillsLimit();
                    _checkTillsLimit();
                    if (self.isEagle) {
                        self.order.tills.map(till => {
                            if (till.tillType.code !== 'BS_ESSENTIEL' && till.tillType.code !== 'BS_PREMIUM'
                                && till.tillType.code !== 'BG_ESSENTIEL' && till.tillType.code !== 'BG_PREMIUM' && till.tillType.code !== 'BM'
                                && till.tillType.code !== 'BM+' && till.tillType.code !== 'BSW_ESSENTIEL' && till.tillType.code !== 'BSW_PREMIUM'
                                && till.tillType.code !== 'BW_ESSENTIEL' && till.tillType.code !== 'BW_PREMIUM' && till.tillType.code !== 'BC_ESSENTIEL') {
                                _resetEagle();
                            } else {
                                self.updateEagle();
                            }
                        });
                    }

                    if (self.bConnectedIsAvailable()) {
                        if (!self.isExtensionScenario()) {
                            if(self.isRenouvellementScenario() && self.hasOnlyMaintenancePackage()) {
                                self.order.bConnected = null;
                            }else {
                                if(self.isBEverConnected()) {
                                    self.order.bConnected = 'FULLEVER';
                                } else {
                                    self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() || self.nbScanup > 0 ? 'FULL' : 'LIGHT';
                                }
                            }
                        } else {
                            self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() || self.nbScanup > 0 ? self.isBEverConnected() ? 'PAWEVER' : 'PAW' : null;
                        }
                    } else {
                        self.order.bConnected = null
                    }

                    let installOption;
                    for (let i = 0; i < self.order.options.length; i++) {
                        if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                            installOption = self.order.options[i];
                    }

                    if(self.isRenouvellementScenario() && self.hasOnlyMaintenancePackage()) {
                        _unselectedOption(installOption)
                    } else {
                       _addPrestationInstallOption(installOption);
                    }

                    if(self.isExceptionalOffer && (tillPackService.isOnlyBGreenPack(self.order.tills)
                        || tillPackService.isOnlyBWidePack(self.order.tills))){
                        self.removeExceptionalOffer();
                        Notification.warning("L'offre du mois a été désactivée.");
                    }

                    if(!self.isClubBimediaOffer)
                        self.order.goodwillGestures.amount.clubBimedia = self.order.contract.contractType.code === 'ACHAT' ? pricesService.priceConverter(7) : 7;


                    self.updateTotal();
                    self.nbTillsOrderModel = orderService.getNbTillsByTillType(self.order.tills);
                });
            };

            /**
             * Open the client modal
             */
            function _openModalDelete() {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'modalConfirmDelete.html',
                    controller: 'FormConfirmDeleteCtrl',
                    controllerAs: 'formConfirmDeleteCtrl'
                });

                modal.result.then(function () {
                    _confirmRemove();
                    self.limitTills = _updateTillsLimit();
                    self.nbTillsOrderModel = orderService.getNbTillsByTillType(self.order.tills);
                    if (!self.hasBmoovPack() && !self.hasBmoovPlusPack() && !self.hasBtouchPack() && !self.hasBtouchPlusPack() && self.isEagle) {
                        self.updateEagle();
                    }
                    if (self.bConnectedIsAvailable() && !self.hasOnlyMaintenancePackage()) {
                        if (!self.isExtensionScenario()) {
                            if(self.isBEverConnected()) {
                                self.order.bConnected = 'FULLEVER';
                            } else {
                                self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() || self.nbScanup > 0 ? 'FULL' : 'LIGHT';
                            }
                        } else {
                            self.order.bConnected = self.hasBmoovPack() || self.hasBmoovPlusPack() || self.nbScanup > 0 ? self.isBEverConnected() ? 'PAWEVER' : 'PAW' : null;
                        }
                    } else {
                        self.order.bConnected = null
                    }

                    let installOption;
                    for (let i = 0; i < self.order.options.length; i++) {
                        if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(self.order.options[i].code))
                            installOption = self.order.options[i];
                    }
                    if(self.isRenouvellementScenario() && self.hasOnlyMaintenancePackage()) {
                        _unselectedOption(installOption)
                    } else {
                        _addPrestationInstallOption(installOption);
                    }

                    if(self.isExceptionalOffer && (tillPackService.isOnlyBGreenPack(self.order.tills)
                        || tillPackService.isOnlyBWidePack(self.order.tills))){
                        self.removeExceptionalOffer();
                        Notification.warning("L'offre du mois a été désactivée.");
                    }

                    if(self.isFullPremiumOffer && (!tillPackService.hasBgreenPack(self.order.tills)
                        || !tillPackService.hasBwidePack(self.order.tills))){
                        self.removeFullPremiumOffer();
                        Notification.warning("L'offre Pack full premium a été désactivée.");
                    }

                    if(self.isBgreenOffer && !tillPackService.hasBgreenPack(self.order.tills)){
                        console.log('suppression offre bgreen');
                        self.removeBgreenOffer(false);
                        Notification.warning("L'offre B Green a été désactivée.");
                    }

                    if(!self.isClubBimediaOffer)
                        self.order.goodwillGestures.amount.clubBimedia = self.order.contract.contractType.code === 'ACHAT' ? pricesService.priceConverter(7) : 7;

                });
            }

            /* Open l'addition offer form selection */
            self.openModalLaddition = function openModalLaddition() {
                var modal = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    templateUrl: 'ladditionForm.html', // modal/laddition.html
                    controller: 'FormLadditionCtrl',
                    controllerAs: 'formLadditionCtrl',
                    size: 'lg',
                    resolve: {
                        order: function () {
                            return self.order;
                        }
                    }
                });

                modal.result.then(function (laddition) {
                    // Update order options with modifications form laddition modal
                    ladditionService.getLadditionOptions(self.order.options).forEach(function (option) {
                        _removeOption(option);
                    });
                    laddition.options.forEach(function (option) {
                        if (option.nbOptions > 0) {
                            _addOption(option);
                        }
                    });

                    if (!self.isContractDefined) {
                        // Valeurs par défaut sur l'order pour qu'elle soit valide pour être envoyée en base
                        self.isContractDefined = true;
                        self.order.contract.scenarioType.code = 'CONQUETE';
                        self.order.contract.contractType.id = self.order.laddition.contractType.id;
                        self.order.contract.contractType.code = self.order.laddition.contractType.code;
                        self.order.contract.contractType.label = self.order.laddition.contractType.label;
                        self.order.dateInstallation = null;
                        self.order.contract.nbTillsAdded = null;
                        self.order.contract.isMudetaf = false;
                        self.order.isScanupOwned = false;
                        self.order.contract.isScanupIncluded = false;
                        self.order.tills = [];
                        self.order.cashDrawers = [];
                        self.order.laddition.options = ladditionService.getLadditionOptions(self.order.options);
                        self.order.laddition.totalPrice = ladditionService.calculateLadditionPrice(self.order.laddition);
                    }
                    self.saveOrder();
                });

                modal.result.catch(function (modalMessage) {
                    $location.path('/bdc/order');
                });
            };

            if (!self.isExtUser()) {
                $scope.$on('$locationChangeStart', function (e, next, current) {
                    if (!self.isSaved && /order/.test(current) && self.isModifiable(self.order)) {
                        self.saveOrder();
                    }
                })
            }

            self.isSaved = true;
            return self;
        }

        OrderCtrl.$inject = [
            '$rootScope',
            '$location',
            '$log',
            'orderFormService',
            'orderService',
            '$scope',
            'pricesService',
            'clientService',
            'Notification',
            'reportRoutingService',
            '$uibModal',
            'marketService',
            'tillPackService',
            'boulangerieService',
            'multiStoresService',
            'userService',
            'goodwillGesturesService',
            'commissionService',
            'ladditionService',
            'tpeService',
            'offerService',
            'contractTypeService',
            'orderTypeService',
            'promotionService',
            'unitBonusService',
            'walletService'
        ];

        angular.module('app.bdc.list.orderCtrl', ['ui-notification', 'ui.bootstrap']).controller('OrderCtrl', OrderCtrl);
    }
);
